import React from 'react';
import { Outlet } from 'react-router-dom';
import { displayComponents, getMapXML, loadFavs, loadVisorLayers } from '../components/Utils/VisorsUtils';
import Navbar from '../components/Navbar/Navbar';
import Sidebar from '../components/Sidebar/Sidebar';
import Catalog from '../components/Catalog/Catalog';
// import ModalInici from '../components/ModalInici/ModalInici';
// import ModalIniciIntranet from '../components/ModalInici/ModalInciniIntranet.js';
import Compartir from '../components/Navbar/Compartir/Compartir';
import Location from '../components/Location/Location';
import Cerca from '../components/Cerca/Cerca';
import CercaAvançada from '../components/Cerca/CercaAvançada/CercaAvançada';
import VectorTilesTools from '../components/VectorTilesTools/VectorTilesTools';
import Llegenda from '../components/Llegenda/Llegenda';
import Ajuda from '../components/Navbar/Ajuda/Ajuda.js';
import InfoAccessibilitat from '../components/Sidebar/PantallaInfo/InfoAccessibilitat';
import InfoCookies from '../components/Sidebar/PantallaInfo/InfoCookies';
import Galeria from '../components/InformacioDePunt/Galeria/Galeria';
import Informacio from '../components/Informacio/Informacio';
import { catalogObj } from '../components/Catalog/Data';
import { navbarObj } from '../components/Navbar/Data';
import { fromLonLat, transformExtent, get, toLonLat, transform } from 'ol/proj';
import { SelectorFonsCartografic } from '../components/SelectorFonsCartografic/SelectorFonsCartografic';
import { register } from 'ol/proj/proj4';
import 'ol/ol.css';
import MousePosition from 'ol/control/MousePosition';
import ScaleLine from 'ol/control/ScaleLine';
import proj4 from 'proj4';
import { HipermapaContainer, NavbarContainer, SidebarContainer, MapContainer, CatalogContainer } from './IndexElements';
import { indexObj as Data } from './Data';
import { View, Map } from 'ol';
import { defaults as defaultControls } from 'ol/control';
import OLTileLayer from 'ol/layer/Tile';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './map.css';
import { cercaElements, cercaLayerElements } from '../components/Cerca/CercaUtils';
import {
  afegirXinxeta,
  centerMapTo,
  esborrarXinxeta,
  obtenirAlçada,
  obtenirInfoPunt,
  getFeatureInfoExternes,
  zoomMapToBBOX,
  getCapabilities,
  loadRedLining,
  createLayer,
  removeLayer,
  repaintLayers
} from '../components/Utils/MapUtils';
import { config } from '../config/Config.js';
import { Layer } from '../models/Layers.js';
import { TileWMS } from 'ol/source';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Circle } from 'ol/style';
import { setQueryParams } from '../components/Navbar/Compartir/CompartirUtils';
import { getTranslatedKey } from '../components/Utils/TranslateUtils';
import $j from 'jquery';
import { isDeepEqual, normalizeText, rasterInfoPunt, solrTextFormat, xmlToJson } from '../components/Utils/FormatUtils';
import TileLayer from 'ol/layer/Tile';
import { createXYZ } from 'ol/tilegrid';
import { styleFunction } from '../components/VectorTilesTools/VectorTilesUtils';
import Preferits from '../components/Preferits/Preferits';
import { getBottomLeft, getCenter, getTopRight } from 'ol/extent';
import { EdicioCapa } from '../components/EdicioCapa/EdicioCapa';
import AlertModal from '../components/AlertModal/AlertModal';
import { createFeature, deleteFeature, getFeatureFields, splitGeom, updateFeature } from '../components/Utils/EdicioCapaUtils';
import { CQLStringMaker, getFeatureByFilter, getTableHits } from '../components/Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Taula/TaulaUtils';
import { Oval } from 'react-loader-spinner';
import axios from 'axios';
import { fetchAndProcessData } from '../components/Utils/infoPuntUtils.js';
import {
  loadLayers,
  zoomToBboxApi,
  getFeatureById,
  goToLocation,
  getBboxFilter,
  getFeaturesWithFilter,
  apiPermissions,
  getParentURL,
  makeGeomMulti
} from '../components/Utils/APIUtils.js';
import { getFeaturesExtent, getLayerBboxWFS } from '../components/Utils/LayerUtils.js';

const selectStyle = new Style({
  image: new Circle({
    radius: 15,
    fill: new Fill({
      color: '#febf0060'
    }),
    stroke: new Stroke({
      color: '#febf00',
      width: 2
    })
  }),
  fill: new Fill({
    color: '#febf0060'
  }),
  stroke: new Stroke({
    color: '#febf0090',
    width: 8
  })
});

const selectFilterStyle = new Style({
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: '#c00000'
    }),
    stroke: new Stroke({
      color: '#c0000060',
      width: 2
    })
  }),
  fill: new Fill({
    color: '#c0000060'
  }),
  stroke: new Stroke({
    color: '#c00000',
    width: 5
  })
});

/**
 * @desc clase del objeto global del Hipermapa
 */
class Hipermapa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false, //variable del estado (abierto/cerrado) del menú desplegable
      mapHeight: parseInt(Math.trunc(window.innerHeight) - 40).toString() + 'px', // variable de estado de la altura del mapa
      mapWidth: parseInt(Math.trunc(window.innerWidth)).toString() + 'px', // variable de estado de la anchura del mapa
      fonsActiu: 0, // variable de estado que indica el fondo del mapa activo
      transparenciaFons: [], // variable de estado que indica la transparencia de cada fondo del mapa
      map: null, // variable de estado del mapa de
      featureOverlay: null,
      vectorTool: null,
      baseLayer: new OLTileLayer({
        source: Data.fons[0].tile,
        zIndex: 0,
        opacity: 100
      }), // variable de estado del fondo del mapa.
      modalIniciOpen: false, // variable de estado abierto/cerrado del modal de inicio
      modalShareOpen: false, // variable de estado abierto/cerrado del modal de compartir
      modalShareKind: '',
      mapSelectOpen: false,
      cercaAvançada: false,
      ajudaOpen: false, // variable de estado abierto/cerrado de la pantalla de ayuda
      infoOpenAccess: false, //variable de estado abierto/cerrado de pantalla de informacion de accesibilidad
      infoOpenCookies: false, //variable de estado abierto/cerrado de pantalla de informacion de cookies
      catalogOpen: false, //variable de estado (abierto/cerrado) del catalogo.
      infoPuntObert: false, //variable de estado abierto/cerrado modal información de punto.
      taulaCapaObert: false, //variable de estado abierto/cerrado modal información de capa.
      alturaInfoPunt: (window.innerHeight - 40) / 3, // variable de estado de la altura del modal de información de punto = un tercio de la altura del mapa.
      alturaBtnCataleg: Data.alturaBtnCatalegBase, //variable de estado de la altura del boton de catalogo.
      alturaBtnSelectorFons: Data.alturaBtnSelectorFonsBase, // variable de estado de la altura del boton del selectorCartogràfico.
      alturaMapControls: Data.alturaMapControlsBase, //variable de estado de la altura de los controles del mapa
      displayInfoPuntBody: true, // variable de estado que indica si se tiene que mostrar o no el body de la información de punto (no se muestra cuando la información de punto se encuentra en su tamaño más pequeño)
      arrayLayers: [], //array con las layers cargadas en la leyenda
      arrayExternalLayers: [], //array con los nombre de las layers externas cargadas en la leyenda
      infoPuntInfo: null, //variable de estado que almacena la información del último punto clicado en el mapa
      nCards: 0, //variable de estado del numero del numero de cartas a mostrar en al info de punto
      clickCoords: null, // variable de estado de las coordenadas del click en el mapa
      hideBottomButtons: false, // variable de estado que indica si, al subir la info de punto, los botones de location, selector y catalgo se tienen que redistribuir/ocultar
      cercaOpen: false, // variable de estado abierto/cerrado de la ventana de cerca
      arElements: [], // variable de estado que almacena la lista de toponimos y elementos de las capas del catalogo de una búsqueda
      arCapesCataleg: [], // variable de estado que almacena la lista de elementos de capas de una búsqueda
      arSolr: [], // variable de estado que almacena la lista de capas de una búsqueda
      catalogData: undefined, // variable de estado que almacena la lista de capas del icgc
      llegendaOpen: false, // variable de estado que indica si la leyenda se encuentra abierta
      cercaPrevia: '', // variable de estado para almacenar la cerca previa
      layersSelectedOnClick: [], //variable de estado que guarda las capas a las que se hacen click
      alçada: null,
      municipi: null,
      adreça: null,
      featureCollect: null,
      fontSizeEnabled: false, //booleano para saber si el switch de accesibilidad de tamaño de letra está on / off
      fontSizeValue: 1.3, //porcentaje añadido al valor inicial de los textos
      sitepLayerInfoMap: [],
      sitepLayerMap: [],
      externalDefaultLayers: [],
      isLoadingEle: false,
      isLoadingCapa: false,
      isLoadingLoc: false,
      requestSolr: null,
      isDrawing: false,
      scale: 0,
      //States de la tabla de datos
      isSelecting: [false, null], // Define si se está seleccionando actualmente y sobre que capa
      selectedArray: {}, // Array de features seleccionadas
      selectedFeatures: {}, // Array de features seleccionadas
      taulaArray: {}, // Objeto con keys layer valores array de propiedades
      taulaFc: {}, // Objeto con keys layer valores array de features
      taulaConditions: {}, //Objeto con keys layer valores array de las condiciones alfanuméricas del filtro
      taulaApiConditions: {}, // Para la API
      taulaResp: {}, //Objeto con keys layer valores respuesta de una petición de ejemplo (se usa para el desplegable de campo)
      taulaPage: {}, // Objeto con keys layer valores página de la tabla
      taulaLayer: null, // Layer actual en la tabla
      taulaTotal: {}, //Objeto con keys layer valores features totales de la capa
      taulaLoading: {}, //Variable para saber si la llamada al servidor para la tabla está pendiente
      taulaFilters: {}, // Filtros alfanuméricos aplicados a la tabla
      taulaSpacialFilter: {}, // Variable para almacenar el filtro espacial seleccionado
      taulaSpacialBbox: {}, //Variable que almacena la BBOX aplicada a un filtro
      taulaFullFilter: {}, //Variable que almacena el filtro final que se manda cuando se aplica un filtro
      taulaGeom: {}, // Variable que almacena la geometría aplicada al filtro
      taulaSorting: {}, //Variable que almacena el filtro final que se manda cuando se aplica un filtro
      //Fin de states de la tabla
      deletedCards: [], // estado que almacena las cartas de info punt que han sido ocultadas
      autoTab: true, // booleano para saber si está activo el cambio automático de pestaña en la cerca
      galeria: { layer: undefined, fotos: [] }, // Almacena las fotos y la capa de un elemento que tenga un enlace del tipo foto
      galeriaOpen: false, // Estado abierto o cerrado de la galeria de imagenes
      galeriaIndex: 0, // Índice de la imagen con la que debe empezar el slider de imagenes
      thumbnailsOpen: false, // Estado abierto o cerrado de la pestaña de imagenes en la ventana de información
      statsObert: false, // Estado abierto o cerrado de la pestaña de estadísticas
      statsLayer: undefined, // Estado abierto o cerrado de la pestaña de estadísticas
      prevClick: {
        features: null,
        clickPixel: null,
        clickCoord: null,
        xinxetaCoords: null
      },
      hadLlegenda: undefined,
      hadInfoPannel: undefined,
      hadAltura: undefined,
      capabilities: undefined,
      favOpen: false,
      favList: [],
      favFeatureInfo: undefined,
      showMedidas: true,
      isEditing: {
        isEditing: false,
        layer: null,
        type: null,
        editFeature: null,
        isDrawing: false
      },
      modalState: {
        showAlert: false,
        alertTitle: 'Alerta',
        alertComponent: undefined,
        background: true,
        center: false
      },
      user: { user: false, aprov: false },
      loading: false,
      apiTab: false,
      apiEnabled: false,
      apiFunctions: {
        mapBbox: false,
        clickInfo: false,
        clickFeatures: false,
        filterResult: false,
        drawFeature: false
      },
      apiDraw: 'disable',
      showEditCard: true,
      editCardProps: undefined,
      updateLlegenda: false
    };
    this.infoPuntCall = 0;
    this.cercaText = '';
    //Para las capas de edición
    this.editSource = new VectorSource();
    this.editVector = new VectorLayer({
      source: this.editSource,
      zIndex: 14,
      style: selectFilterStyle
    });

    // Para las capas de medir
    this.vectorTilesSource = new VectorSource();
    this.vectorTilesVector = new VectorLayer({
      source: this.vectorTilesSource,
      style: (feature) => {
        return styleFunction(feature, false, true, undefined, false, this.state.showMedidas);
      },
      zIndex: 200
    });

    // Para las capas de filtraje
    this.filterSource = new VectorSource();
    this.filterVector = new VectorLayer({
      source: this.filterSource,
      style: (feature) => {
        return styleFunction(feature, false, false, undefined, true, this.state.showMedidas);
      },
      zIndex: 200
    });

    // Para el resalado de las seleccionadas
    this.selectSource = new VectorSource();
    this.selectVector = new VectorLayer({
      source: this.selectSource,
      style: selectFilterStyle,
      zIndex: 199
    });

    this.updateDimensionsMapa = this.updateDimensionsMapa.bind(this);
    this.arCapesCataleg = [];
    this.arElements = [];
    this.arSolr = [];
  }

  /**
   * @desc cuando se monta el componente, se inicializa la variable de estado de las propiedades del mapa
   */
  async componentDidMount() {
    this.ApiInitiator();
    window.addEventListener('resize', this.updateDimensionsMapa);
    // Fetch de capabilities para conseguir el zoom a toda la layer
    this.getCapabilities();
    this.onResizeInfoPuntCard(0);

    this.setState({ transparenciaFons: Array(Data.fons.length).fill(1) });
    this.updateDimensionsMapa();
    await this.createMap();
    if (this.props.visor?.layers?.length > 0 || new URLSearchParams(window.location.search).get('layers')) {
      this.setState({ loading: true });
    }
    await this.getUser();

    await this.displayCatalogData();
    while (this.state.sitepLayerInfoMap.length === 0) {
      await new Promise((resolve) => setTimeout(resolve, 200));
    }

    setQueryParams(this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);

    if (this.props.visor?.layers?.length > 0 && this.state.arrayLayers.length === 0) {
      loadVisorLayers(this.props.visor?.layers, this);
    }

    if (this.props.visor?.redLining) {
      const fc = new GeoJSON().readFeatures(this.props.visor.redLining, {
        dataProjection: config.EPSG,
        featureProjection: config.EPSG_mapa
      });
      loadRedLining(fc, this.vectorTilesSource, this.state.map, this.state.arrayLayers, this.handleLayerArrayChange);
    }

    if (this.props.visor?.favs) {
      loadFavs(this.props.visor?.favs, this);
    }

    this.setState({});
  }

  getCapabilities = async () => {
    const capabilitiesResp = await getCapabilities();
    this.setState({ capabilities: capabilitiesResp });
  };

  getUser = async () => {
    await fetch(config.url_getUser)
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
      })
      .then((text) => {
        let aprov = false;
        const numbers = text.slice(0, -1);
        let isnum = /^\d+$/.test(numbers);
        if (isnum) aprov = true;

        this.setState({ user: { user: true, aprov: aprov } });
      })
      .catch((e) => {});
  };
  /**
   * @desc mètode a executar quan el component es destrueix o es desmonta al DOM
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensionsMapa);
  }

  // //Por si se pone la escala en vez de los km
  // componentDidUpdate = (prevProps, prevState) => {
  //   const scaleBarTexts = document.getElementsByClassName('ol-scale-step-text');

  //   for (let i = 0; i < scaleBarTexts.length; i++) {
  //     scaleBarTexts[i].classList.add(`ol-text-num-${i}`);
  //     if (i === 1) {
  //       const currentMarginLeft = window.getComputedStyle(scaleBarTexts[i]).marginLeft;
  //       const newMarginLeft = parseInt(currentMarginLeft) + 20 + 'px';
  //       scaleBarTexts[i].style.marginLeft = newMarginLeft;
  //     }
  //   }
  // };

  coordinateFormat = (coord) => {
    let lonLat = toLonLat(coord, config.EPSG);
    let lonLatCoords = 'WGS84: ' + lonLat[1].toFixed(6) + ' ' + lonLat[0].toFixed(6);
    const UTM = 'ETRS89 - UTM31N: ' + coord[0].toFixed(2) + ' ' + coord[1].toFixed(2) + ' // ';

    if (lonLat[0] > 0 && lonLat[0] < 6 && lonLat[1] > 40 && lonLat[1] < 48) {
      return UTM + ' ' + lonLatCoords;
    } else {
      return lonLatCoords;
    }
  };

  /**
   * @desc función de inicialización para crear el mapa
   */
  createMap = async () => {
    const self = this;
    // establecer projección del mapa
    proj4.defs(config.EPSG, '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

    register(proj4);

    //elemento de indicación de la coordenada geogràfica de la posición del mouse en el mapa
    const mousePositionControl = new MousePosition({
      coordinateFormat: this.coordinateFormat,
      projection: config.EPSG,
      placeholder: '',
      className: 'custom-mouse-position',
      id: 'mouse-pos'
    });

    //elemento de escala del mapa
    const scaleLine = new ScaleLine({
      units: 'metric',
      type: 'scaleline',
      // bar: true,
      // text: true,
      // steps: 1,
      // minWidth: 100,
      // maxWidth: 200,
      // className: 'custom-scale-bar',
      className: 'custom-scale-line',
      id: 'scale-line',
      bottomInUnits: '',
      geodesic: true
    });

    if (document.getElementsByClassName('ol-viewport').length === 0) {
      let map = new Map({
        layers: [this.state.baseLayer, this.vectorTilesVector, this.filterVector, this.selectVector, this.editVector],
        target: 'mapContainer',
        moveTolerance: 5,
        pixelRatio: 1,
        updateSize: this.updateDimensionsMapa,
        view: new View({
          projection: get(config.EPSG_mapa),
          center: fromLonLat([1.8411453, 41.7383435]),
          constrainResolution: true,
          resolutions: [
            156543.03392804097, 78271.51696402048, 39135.75848201024, 19567.87924100512, 9783.93962050256, 4891.96981025128, 2445.98490512564,
            1222.99245256282, 611.49622628141, 305.748113140705, 152.8740565703525, 76.43702828517625, 38.21851414258813, 19.109257071294063,
            9.554628535647032, 4.777314267823516, 2.388657133911758, 1.194328566955879, 0.5971642834779395, 0.29858214173896974, 0.14929107086948487
          ],
          enableRotation: false
        }),

        controls: defaultControls({
          attribution: false,
          rotate: false,
          zoom: false
        }).extend([scaleLine, mousePositionControl]),
        overlays: []
      });
      if (!displayComponents.escala) map.removeControl(scaleLine);
      if (!displayComponents.mousePos) map.removeControl(mousePositionControl);

      this.setState(
        {
          featureOverlay: new VectorLayer({
            map: map,
            source: new VectorSource(),
            style: selectStyle,
            zIndex: '14'
          })
        },
        () => {
          const queryParams = new URLSearchParams(window.location.search);
          let bboxParam = queryParams.get('BBOX')?.split(',').map(Number);
          if (bboxParam) {
            let diagonal = [getBottomLeft(bboxParam), getTopRight(bboxParam)];
            diagonal[0] = transform(diagonal[0], config.EPSG, config.EPSG_mapa).map(Math.ceil);
            diagonal[1] = transform(diagonal[1], config.EPSG, config.EPSG_mapa).map(Math.floor);
            diagonal = diagonal.reduce((acc, curr) => acc.concat(curr), []);
            bboxParam = diagonal;
          }
          let bbox = bboxParam || this.props.visor?.bbox;
          let background = queryParams.get('background') || this.props.visor?.capaFons;
          let transp = queryParams.get('bg_transp') || this.props.visor?.transparenciaFons;

          if (bbox) {
            map.getView().fit(bbox);
          } else {
            map.getView().fit(transformExtent([258000, 4485000, 536000, 4752000], config.EPSG, config.EPSG_mapa));
          }

          if ((!this.props.visor || this.props.id === config.idIntranet || this.props.id === config.idHipermapa) && !this.props.map) {
            let shouldModal = localStorage.getItem('showNewModalNews');
            if (shouldModal == null) {
              this.setState({ modalIniciOpen: true });
            }
          }

          if (background) {
            if (background === 'topo_ICC') {
              this.onChangeFonsActiuMapa(0);
            } else if (background === 'topo_ICC_grisos') {
              this.onChangeFonsActiuMapa(1);
            } else if (background === 'orto_ICC') {
              this.onChangeFonsActiuMapa(4);
            } else if (background === 'orto_ICC_grisos') {
              this.onChangeFonsActiuMapa(4);
            } else if (background === 'limit_icc') {
              this.onChangeFonsActiuMapa(6);
            } else if (background === 'shaded_relief') {
              this.onChangeFonsActiuMapa(0);
            } else {
              Data.fons.forEach((fons, index) => {
                if (fons.tileName === background) {
                  this.onChangeFonsActiuMapa(index);
                }
              });
            }

            if (transp) {
              transp = Number(transp);
              this.onChangeTransparenciaMapa(this.state.fonsActiu, transp * 100);
            }
          }
        }
      );
      map.on('singleclick', async (e) => {
        if (!this.state.isDrawing && !this.state.isEditing.isDrawing) {
          if (!this.state.isSelecting[0]) {
            await esborrarXinxeta(map);
            let pixel = map.getEventPixel(e.originalEvent);
            pixel[0] = pixel[0].toFixed();
            pixel[1] = pixel[1].toFixed();
            let coords = map.getCoordinateFromPixel([pixel[0], pixel[1]]);
            let xinxetaCoords = map.getCoordinateFromPixel([pixel[0], pixel[1]]);

            let layers = [];
            let extLayers = [];
            if (displayComponents.infoCapa) {
              self.state.arrayLayers.forEach((layer) => {
                if (layer.isExternal() && !layer.isTemporal()) extLayers.push(layer);
                let data = layer.getOLLayer().getData(pixel);
                if (data !== null && layer.hasInfoEnabled()) {
                  layers.push(layer);
                }
              });

              if (extLayers.length > 0) {
                await getFeatureInfoExternes(extLayers.toReversed(), self.state.map, self.state.mapHeight, self.state.mapWidth, pixel);
              }
            }
            await esborrarXinxeta(map);
            await self.onClickMap(layers, pixel, coords, xinxetaCoords);
          } else {
            let pixel = map.getEventPixel(e.originalEvent);
            pixel[0] = pixel[0].toFixed();
            pixel[1] = pixel[1].toFixed();

            let layer = null;

            let data = this.state.isSelecting[1].getOLLayer().getData(pixel);
            if (data !== null) {
              layer = this.state.isSelecting[1];
            }

            this.getSelectedFeatures(layer, pixel);
          }
        }
      });
      map.on(
        'moveend',
        function () {
          this.setState({
            scale: Math.round(39.37 * 72 * map.getView().getResolution() * 0.9407)
          });
          if (this.state.apiEnabled && this.state.apiFunctions.mapBbox) {
            const message = {
              infoName: 'mapBbox',
              data: transformExtent(map.getView().calculateExtent(map.getSize()), config.EPSG_mapa, config.EPSG)
            };
            window.parent.postMessage(message, getParentURL());
          }
        }.bind(this)
      );
      map.on('pointermove', function (event) {
        if (event.dragging) {
          map.getTargetElement().style.cursor = 'grabbing';
        } else {
          map.getTargetElement().style.cursor = 'default';
        }
      });
      map.once('rendercomplete', () => {
        const mapViewport = this.state.map.getViewport();
        const canvas = mapViewport.querySelector('canvas');
        const context = canvas.getContext('2d');
        context.willReadFrequently = true;
      });

      this.setState({
        map: map
      });
    }
  };

  /**
   * @param {*} evt
   * @desc Función encargada de obtener las información de las capas y abrir la información de punto
   */

  onClickMap = async (layers, clickPixel, clickCoord, xinxetaCoords, fav) => {
    let prevClickCoord = clickCoord;
    clickCoord = proj4(config.EPSG_mapa, config.EPSG, clickCoord);
    const date = Date.now();
    this.infoPuntCall = date;
    const infoComparison = date;
    if (displayComponents.infoCapa || displayComponents.infoPuntInfo) {
      await esborrarXinxeta(this.state.map);
      this.setState({ deletedCards: [] });
      this.setState({
        isOpen: false,
        infoPuntInfo: null,
        layersSelectedOnClick: [],
        nCards: 0,
        prevClick: {
          features: layers,
          clickPixel: clickPixel,
          clickCoord: prevClickCoord,
          xinxetaCoords: xinxetaCoords
        }
      });
      this.toggleCatalog(false);
      this.toggleMapSelector(false);
      let urls = [];
      let rasterUrls = [];

      if (!fav) {
        await afegirXinxeta(xinxetaCoords, this.state.map);

        this.state.featureOverlay.getSource().clear();

        layers.forEach((layer) => {
          if (!layer.isExternal() && !layer.isRasterLayer()) {
            const or = layer.getOnlineResource();
            const foundIndex = urls.findIndex((obj) => Object.keys(obj).some((key) => key === or));

            if (foundIndex === -1) {
              urls.push({ [or]: [layer] });
            } else {
              const existingArray = Object.values(urls[foundIndex])[0];
              existingArray.push(layer);
            }
          } else if (layer.isRasterLayer()) {
            const or = layer.getOnlineResource();
            const foundIndex = rasterUrls.findIndex((obj) => Object.keys(obj).some((key) => key === or));

            if (foundIndex === -1) {
              rasterUrls.push({ [or]: [layer] });
            } else {
              const existingArray = Object.values(rasterUrls[foundIndex])[0];
              existingArray.push(layer);
            }
          }
        });
      }
      if (displayComponents.infoPuntInfo) this.openInfoPunt(clickCoord, clickPixel, fav);
      obtenirAlçada(clickCoord[0].toFixed(2), clickCoord[1].toFixed(2), this);

      obtenirInfoPunt(clickCoord[1].toFixed(2), clickCoord[0].toFixed(2), this);

      if (layers.length > 0 && !fav) {
        let self = this;
        let ext = this.state.map.getView().calculateExtent(this.state.map.getSize());
        let bbox = ext[0] + ',' + ext[1] + ',' + ext[2] + ',' + ext[3];
        if (this.infoPuntCall === infoComparison) {
          let responses = await fetchAndProcessData(urls, bbox, clickPixel, this.state.taulaFullFilter);
          if (rasterUrls.length > 0) {
            const rasterResp = await rasterInfoPunt(rasterUrls, bbox, clickPixel, this.state.sitepLayerInfoMap);
            responses = responses.concat(rasterResp);
          }
          if (this.infoPuntCall === infoComparison) {
            self.setState(
              {
                infoPuntInfo: responses,
                layersSelectedOnClick: layers,
                nCards: responses.length
              },
              () => {
                if (!displayComponents.infoPuntInfo) {
                  if (self.state.infoPuntInfo.length > 0) {
                    self.openInfoPunt(clickCoord, clickPixel, fav);
                  } else {
                    self.tancarInfoPunt();
                  }
                } else {
                  self.openInfoPunt(clickCoord, clickPixel, fav);
                }
              }
            );
          }
        }
      } else {
        this.setState(
          {
            infoPuntInfo: layers,
            layersSelectedOnClick: layers,
            nCards: layers.length
          },
          () => {
            if (this.state.infoPuntInfo.length > 0) this.openInfoPunt(clickCoord, clickPixel, fav);
          }
        );
      }
    }
  };
  tancarInfoPunt = () => {
    if (Object.keys(this.state.taulaArray)?.length > 0) {
      this.tableInfoToggle('table');
    } else if (this.state.statsLayer) {
      this.tableInfoToggle('stats');
    } else {
      this.onResizeInfoPuntCard(0);
    }
    this.setState({
      infoPuntObert: false,
      displayInfoPuntBody: false,
      clickCoords: null,
      layersSelectedOnClick: []
    });
  };
  openInfoPunt = (clickCoord, clickPixel, fav) => {
    const altura = window.innerHeight < 700 ? (window.innerHeight - 40) / 2.5 : (window.innerHeight - 40) / 3;

    this.setState(
      {
        infoPuntObert: true,
        taulaCapaObert: false,
        thumbnailsOpen: false,
        statsOpen: false,
        cercaOpen: false,
        cercaAvançada: false,
        displayInfoPuntBody: true,
        alturaInfoPunt: altura,
        clickCoords: clickCoord
      },
      () => {
        this.onResizeInfoPuntCard(altura);
        if (clickPixel !== null && this.state.mapHeight.split('px')[0] - clickPixel[1] <= this.state.alturaInfoPunt && !fav)
          centerMapTo(clickCoord, this.state.map, false, true, this.state.alturaInfoPunt, false);
      }
    );
  };

  /**
   * @desc funció para cambiar el estado de apertura del menú lateral
   * @param {*} toggle
   */
  toggleMenuLateral = (toggle) => {
    this.setState({
      isOpen: typeof toggle !== 'undefined' ? toggle : !this.state.isOpen
    });
  };

  /**
   * @desc función para cambiar el estado de apertura del catalogo
   * @param {*} toggleCatalog
   */
  toggleCatalog = (toggleCat) => {
    this.setState(
      {
        catalogOpen: typeof toggleCat !== 'undefined' ? toggleCat : !this.state.catalogOpen
      },
      () => {
        if (this.state.catalogOpen === true) {
          this.setState({
            cercaOpen: false,
            cercaAvançada: false,
            llegendaOpen: false
          });
        }
        if (window.innerWidth < 520 + 480 + 20) {
          this.setState({ mapSelectOpen: false, favOpen: false });
        }
        this.memoria(this.state.catalogOpen, true);
      }
    );
  };

  /**
   * @desc función para cambiar si se muestran medidas o no
   * @param {boolean} showMedidas
   */
  toggleMedidas = (showMedidas = undefined) => {
    if (showMedidas === undefined) {
      this.setState({ showMedidas: !this.state.showMedidas }, () => this.vectorTilesSource.changed());
      return;
    }
    this.setState({ showMedidas: showMedidas }, () => this.vectorTilesSource.changed());
  };

  /**
   * @desc funció per modificar la variable d'estat de l'altura del mapa quan la finestra es modifiqui
   */
  updateDimensionsMapa() {
    let heightCollapsed = Math.trunc(window.innerHeight) - Data.navHeightCollapsed;
    let heightNormal = Math.trunc(window.innerHeight) - Data.navHeight;
    this.setState({
      mapHeight: window.innerWidth <= 768 ? heightCollapsed.toString() + 'px' : heightNormal.toString() + 'px',
      mapWidth: parseInt(window.innerWidth).toString() + 'px'
    });

    if (this.state.map !== null && this.state.map !== 'undefined') {
      this.state.map.setSize([parseInt(window.innerWidth), window.innerWidth <= 768 ? heightCollapsed : heightNormal]);
    }

    if (this.state.infoPuntObert || this.state.taulaCapaObert || this.state.thumbnailsOpen || this.state.statsOpen)
      document.documentElement.style.setProperty('--bottom', Data.alturaMapControlsBase + 'px');
    else document.documentElement.style.setProperty('--bottom', 2 + 'px');
  }

  /**
   * @param {*} newInfoCardHeigth
   * @desc Función encargada de modificar la altura a la que se encuentran los botones del mapa cuando se redimensiona la información de punto
   */
  onResizeInfoPuntCard(newInfoCardHeigth, operacio) {
    if (newInfoCardHeigth !== 0) {
      let mapHeight = Math.trunc(window.innerHeight) - Data.navHeight;

      // Tractament per movil
      if (window.innerWidth < 464) {
        // si es posiciona a menys d'un terci de la pantalla
        if (operacio === 'max' && this.state.alturaInfoPunt === window.innerHeight / 2) {
          newInfoCardHeigth = mapHeight - 40;
        }
      }

      //Tractament per tablet i movil en horizontal
      else if (window.innerWidth < 1024) {
        // tractament per quan es troba horizontal
        if (window.innerHeight < 464) {
          //!IMPORTANT -> Jo haria directamente pantalla completa
          // si es posiciona a menys d'un terci de la pantalla
          if (newInfoCardHeigth < mapHeight / 3) newInfoCardHeigth = 35;
          // si es posiciona a més d'un quart de la pantalla
          if (newInfoCardHeigth > mapHeight / 3) newInfoCardHeigth = mapHeight;
        }
        //tractament per quan es troba vertical
        else {
          // si es posiciona a menys d'un quart de la pantalla
          if (newInfoCardHeigth < mapHeight / 4) newInfoCardHeigth = 35;
          // si es posiciona a més d'un quart de la pantalla
          if (newInfoCardHeigth > (mapHeight / 3) * 2) newInfoCardHeigth = (mapHeight / 3) * 2;
        }
      }

      //tractament per ordinador
      else {
        // si es posiciona a menys d'un sisé de la pantalla
        if (newInfoCardHeigth < mapHeight / 6) newInfoCardHeigth = 35;
        // si es posiciona entre un sisé i dos sisens de la pantalla
        if (newInfoCardHeigth > mapHeight / 6 && newInfoCardHeigth <= mapHeight / 3) newInfoCardHeigth = (mapHeight - 40) / 3;
        // si es posiciona a més d'un terci de la pantalla
        if (newInfoCardHeigth > (mapHeight / 3) * 2) newInfoCardHeigth = (mapHeight / 3) * 2;
      }
    }

    //tractament de redistribució/ocultació de botons
    let hideBtns = false;
    if (window.innerHeight - 40 - newInfoCardHeigth < 190) {
      hideBtns = true;
    }
    this.setState(
      {
        alturaInfoPunt: newInfoCardHeigth,
        hideBottomButtons: hideBtns,
        alturaBtnCataleg: Data.alturaBtnCatalegBase - 15 + newInfoCardHeigth,
        alturaBtnSelectorFons: Data.alturaBtnSelectorFonsBase - 15 + newInfoCardHeigth,
        alturaMapControls: Data.alturaMapControlsBase + newInfoCardHeigth
      },
      () => {
        if (this.state.infoPuntObert || this.state.taulaCapaObert)
          document.documentElement.style.setProperty('--bottom', Data.alturaMapControlsBase + newInfoCardHeigth + 10 + 'px');
        else document.documentElement.style.setProperty('--bottom', Data.alturaMapControlsBase + 'px');
      }
    );
  }

  /**
   * @param {*} fonsActiu
   * @desc función para modificar el estado de la varible del fondo activo del mapa
   */
  onChangeFonsActiuMapa = (fonsActiu) => {
    this.setState({ fonsActiu: fonsActiu });
    this.state.baseLayer.setSource(Data.fons[fonsActiu].tile);
    this.state.baseLayer.setOpacity(this.state.transparenciaFons[fonsActiu]);
  };

  /**
   * @param {*} i
   * @param {*} transp
   * @desc función para modificar el estado del array de transparencias del fondo del mapa activo
   */
  onChangeTransparenciaMapa = (i, transp) => {
    let transparenciaFonsOld = this.state.transparenciaFons;
    transparenciaFonsOld[i] = transp / 100;
    this.setState({ transparenciaFons: transparenciaFonsOld });
    this.state.baseLayer.setOpacity(this.state.transparenciaFons[i]);
  };

  /**
   * @param {*} operacio
   * @desc función encargada de abrir/cerrar la información de un punto y actualizar la posicion de los botones afectados:
   * Catalog, Controls, Location, Selector
   */
  onClickInfoPunt = (operacio, evt) => {
    if (operacio === 'max') {
      if (this.state.alturaInfoPunt < window.innerHeight / 4) {
        this.onResizeInfoPuntCard(window.innerHeight / 4, operacio);
      } else if (this.state.alturaInfoPunt < window.innerHeight / 2) {
        this.onResizeInfoPuntCard(window.innerHeight / 2, operacio);
      } else {
        this.onResizeInfoPuntCard(window.innerHeight, operacio);
        this.setState({ llegendaOpen: false });
      }
    } else if (operacio === 'min') {
      if (this.state.alturaInfoPunt <= window.innerHeight / 2) {
        this.onResizeInfoPuntCard(window.innerHeight / 4, operacio);
      } else {
        this.onResizeInfoPuntCard(window.innerHeight / 2, operacio);
        this.setState({ displayInfoPuntBody: true });
      }
    } else if (operacio === 'fullMin') {
      this.onResizeInfoPuntCard(25);
    } else if (operacio === 'close') {
      this.setState(
        {
          infoPuntObert: false,
          displayInfoPuntBody: false,
          taulaCapaObert: false,
          thumbnailsOpen: false,
          statsOpen: false,
          clickCoords: null,
          layersSelectedOnClick: []
        },
        async () => {
          this.onResizeInfoPuntCard(0);
          await esborrarXinxeta(this.state.map);
          this.state.featureOverlay.getSource().clear();
          evt && this.closeAllTabs(evt);
          evt && this.closeThumbnails(evt);
        }
      );
    }
  };

  handleEraseInfoCard = (layer) => {
    let name = layer.getName();
    let indexes = [];
    this.state.infoPuntInfo?.forEach((feature, index) => {
      let layerName = feature.id_.split('.')[0];
      if (layerName !== '' && layerName !== undefined && layerName !== null) {
        let layerSelected;
        for (let i = 0; i < this.state.layersSelectedOnClick.length; ++i) {
          layerSelected = this.state.layersSelectedOnClick[i];
          if (layerSelected.Name === layerName || layerSelected.getName() === layerName) {
            if (layerSelected === layer) {
              indexes.push(index);
            }
          }
        }
      }
    });
    if (indexes.length > 0) {
      if ((layer.isVisible() && !layer.hasInfoEnabled()) || (!layer.isVisible() && layer.hasInfoEnabled())) {
        for (let i = 0; i < indexes.length; i++) {
          let obj = {};
          obj[name] = this.state.infoPuntInfo[indexes[i]];
          this.state.deletedCards.push(obj);
        }
        for (let i = indexes.length - 1; i >= 0; i--) {
          this.state.infoPuntInfo.splice(indexes[i], 1);
        }
      }
    } else {
      if (layer.isVisible() && layer.hasInfoEnabled()) {
        let deletedIdx = [];
        this.state.deletedCards.forEach((card, i) => {
          if (card[name]) {
            this.state.infoPuntInfo.unshift(card[name]);
            deletedIdx.push(i);
          }
        });
        for (let i = deletedIdx.length - 1; i >= 0; i--) {
          this.state.deletedCards.splice(deletedIdx[i], 1);
        }
      }
    }
    this.setState({});
  };

  handleLayerArrayChange = async () => {
    if (
      this.state.isEditing.isEditing &&
      this.state.arrayLayers.findIndex((layer) => layer.getName() === this.state.isEditing.layer.getName()) === -1
    ) {
      this.setEditing(false, this.state.isEditing.layer);
    }
    await esborrarXinxeta(this.state.map);
    this.changeLlegendaOpen(this.state.llegendaOpen);
    if (this.state.infoPuntObert) {
      let layers = [];
      if (displayComponents.infoCapa) {
        this.state.layersSelectedOnClick.forEach((layer) => {
          let isCurrent = this.state.arrayLayers.includes(layer);
          if (isCurrent && layer.isVisible() && layer.hasInfoEnabled()) {
            layers.push(layer);
          }
        });
      }
      await esborrarXinxeta(this.state.map);
      await this.onClickMap(layers, this.state.prevClick.clickPixel, this.state.prevClick.clickCoord, this.state.prevClick.xinxetaCoords);
    }
    const statLayer = this.state.arrayLayers.find((layer) => layer.getName() === this.state.statsLayer?.getName());
    const galleryLayer = this.state.arrayLayers.find((layer) => layer.getName() === this.state.galeria.layer?.getName());
    if (!statLayer) {
      this.closeStatsTab();
    }
    if (!galleryLayer) {
      this.closeThumbnails();
    }
    this.state.featureOverlay.getSource().clear();
  };

  /**
   * @param {*} coords
   * @desc función encargada de situar al usuario en el mapa en el lugar de su geolocalización
   */
  onClickGeolocalitzacioMapa = async (coords) => {
    let arCoord = fromLonLat([coords.coords.longitude, coords.coords.latitude]);
    await esborrarXinxeta(this.state.map);

    await centerMapTo(arCoord, this.state.map, true, false, this.state.alturaInfoPunt, true);

    await this.onClickMap([], null, arCoord, [arCoord[0], arCoord[1]]);
  };

  obrirInfoSolr = async (fc, name, coords) => {
    let layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === name);
    await this.onClickMap([], null, coords, [coords[0], coords[1]]);

    this.setState({
      infoPuntInfo: fc,
      layersSelectedOnClick: [layer],
      nCards: fc.length
    });

    if (fc[0] === undefined || fc.length === 0) {
      toast.error(getTranslatedKey('error_cercaElement'), {
        autoClose: 4000,
        pauseOnHover: true
      });
    } else {
      let altura = (window.innerHeight - 40) / 3;
      zoomMapToBBOX(this.state.map, fc[0]?.getGeometry().getExtent(), altura);
      this.state.featureOverlay.getSource().addFeature(fc[0]);

      //let coordsPixel = this.state.map.getPixelFromCoordinate(coords);
      //let xinxetaCoords = this.state.map.getCoordinateFromPixel([coordsPixel[0], coordsPixel[1] - 16]);
    }
  };

  /**
   * @param {*} coords
   * @desc Función encargada de hacer zoom a la posición del elemento de la cerca
   */
  onClickElementCerca = async (coords, isGeolocalitzacio, isETRS, isElement, id, name, infoPunt = true) => {
    if (isElement) {
      cercaLayerElements(id, name, coords, this.obrirInfoSolr, this.state.sitepLayerInfoMap);
      this.setState({ cercaOpen: false, cercaAvançada: false });
      return;
    }
    coords = coords.map((coord) => (typeof coord === 'string' ? Number(coord.replace(/\s/g, '')) : coord));
    let altura = window.innerWidth / 3;
    let arCoords;

    if (coords[0] <= 180 && coords[0] >= -180 && coords[1] <= 90 && coords[1] >= -90) {
      // LatLon
      arCoords = fromLonLat([coords[0], coords[1]]);
    } else {
      if (isGeolocalitzacio === true) {
        arCoords = coords;
      } else {
        // ETRS89
        arCoords = proj4(config.EPSG, config.EPSG_mapa, coords);
      }
    }

    await centerMapTo(coords, this.state.map, isGeolocalitzacio, isETRS, altura, true, infoPunt);
    this.setState({ cercaOpen: false, cercaAvançada: false });
    if (infoPunt) {
      await this.onClickMap([], null, arCoords, [arCoords[0], arCoords[1]]);
    }
  };

  /**
   * @desc función encargada de indicar al usuario que no se ha podido obtener su geolocalización
   */
  onGeolocalitzacioError = (err) => {
    toast.info(getTranslatedKey('error_obtainLocation'), {
      autoClose: 4000,
      pauseOnHover: true
    });
  };

  /**
   * @desc Función encargada de cerrar la pestaña de la cerca
   */
  onClickCloseCerca = () => {
    this.setState({ cercaOpen: false }, () => {
      this.memoria(false);
    });
  };

  toggleAutoTab = (bool) => {
    this.setState({ autoTab: bool });
  };

  toggleLoadingLoc = (isLoading) => {
    this.setState({ isLoadingLoc: isLoading });
  };

  /**
   * @desc funcion para capturar si se borra una capa de la leyenda
   */
  handleDeleteLayer = () => {
    if (this.state.arrayLayers.length === 0) {
      this.changeLlegendaOpen(false);
      this.onClickInfoPunt('close');
    } else this.changeLlegendaOpen(this.state.llegendaOpen);
    this.handleLayerArrayChange();
  };
  /**
   * @desc Función de búsqueda que se ejecuta cuando se realiza una 'cerca'
   */
  onClickCerca = async (cerca) => {
    this.state.isLoadingCapa = true;
    this.state.isLoadingEle = true;
    this.state.isLoadingLoc = true;

    this.setState(
      {
        catalogOpen: null,
        cercaAvançada: null,
        isOpen: null,
        infoOpenAccess: null,
        infoOpenCookies: null
      },
      () =>
        this.setState({
          catalogOpen: false,
          favOpen: false,
          isOpen: false,
          cercaAvançada: false,
          infoOpenAccess: false,
          infoOpenCookies: false,
          galeriaOpen: false
        })
    );

    let inputCerca = window.innerWidth > 768 ? document.getElementById('inputCerca') : document.getElementById('inputCercaCollapsed');
    let search = inputCerca.value || cerca;
    if (search === '' || search === undefined || search === null || typeof search === 'undefined' || search.length === 0) {
      this.handleCercaBuida();
    } else {
      this.arCapesCataleg = [];
      this.arElements = [];
      this.arSolr = [];

      displayComponents.cercaLayers && this.cercaCataleg(search);
      displayComponents.cercaFeatures && this.cercaSolr(search);
      displayComponents.cercaPlaces &&
        (await cercaElements(this.addCercaToponim, this.clearArElements, this.onClickElementCerca, search, this.toggleLoadingLoc));
      if (this.state.cercaOpen !== true) {
        this.memoria(true);
        this.setState({ cercaOpen: true, cercaPrevia: search });
      }
      this.toggleMapSelector(false);
    }
  };
  loadingCatalog = async () => {
    if (this.state.sitepLayerInfoMap.length === 0) {
      this.setState({ loading: true });
      while (this.state.sitepLayerInfoMap.length === 0) {
        await new Promise((resolve) => setTimeout(resolve, 200));
      }
      this.setState({ loading: false });
    }
  };

  //Funciones de la API
  apiSearch = (text, tab) => {
    this.setState({ loading: true }, async () => {
      while (this.state.sitepLayerInfoMap.length === 0) {
        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      this.onClickCerca(text);
      this.setState({ loading: false, apiTab: tab });
    });
  };

  loadMapById = async (id) => {
    id = id.split('/');
    id = id[id.length - 1];
    let xml = await getMapXML(id);
    this.props.loadMap(xml);
  };

  loadLayersLlegenda = async (layer, styleInput) => {
    await this.loadingCatalog();
    await loadLayers(layer, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    const sitepLayer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layer);
    if (sitepLayer) {
      sitepLayer.getStyles().forEach(async (style, idx) => {
        if (style.getName() === styleInput) {
          this.state.map.removeLayer(sitepLayer.getOLLayer());
          await createLayer(sitepLayer, this.state.map, this.state.arrayLayers, false, styleInput, false);
          sitepLayer.setStyleSelected(idx);
          repaintLayers(this.state.map, this.state.arrayLayers);
        }
      });
    }
  };

  unloadLayersLlegenda = async (layer) => {
    if (this.state.arrayLayers.length > 0) {
      removeLayer(this.state.map, layer, this.state.arrayLayers, this.state.externalDefaultLayers, this.handleDeleteLayer, this.deleteTaula);
    }
  };

  goToElementByID = async (layerName, elementID, showCard) => {
    await this.loadingCatalog();
    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    const sitepLayer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    if (sitepLayer) {
      const feature = await getFeatureById(sitepLayer, elementID);
      let extent = feature.getGeometry().getExtent();

      zoomMapToBBOX(this.state.map, extent, false, true);

      if (showCard) {
        const center = getCenter(extent);
        let layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
        await this.onClickMap([], center, center, [center[0], center[1]], false);

        this.setState({
          infoPuntInfo: [feature],
          layersSelectedOnClick: [layer],
          nCards: 1
        });
      }
      this.state.featureOverlay.getSource().clear();
      this.state.featureOverlay.getSource().addFeature(feature);
    }
  };

  apiGoToElementByFilter = async (layerName, field, value, showCard) => {
    await this.loadingCatalog();
    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    const fc = await getFeaturesWithFilter(
      layerName,
      field,
      value,
      this.state.sitepLayerInfoMap,
      this.state.arrayLayers,
      this.state.map,
      this.state.externalDefaultLayers
    );
    if (fc.length === 1) {
      let extent = fc[0].getGeometry().getExtent();
      zoomMapToBBOX(this.state.map, extent, false, true);
      if (showCard) {
        const center = getCenter(extent);
        let layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
        await this.onClickMap([], center, center, [center[0], center[1]], false);

        this.setState({
          infoPuntInfo: [fc[0]],
          layersSelectedOnClick: [layer],
          nCards: 1
        });
      }
      this.state.featureOverlay.getSource().clear();
      this.state.featureOverlay.getSource().addFeature(fc[0]);
    } else if (fc.length > 1) {
      this.setState({ infoPuntObert: false, infoPuntInfo: null, clickCoords: null }, async () => {
        await esborrarXinxeta(this.state.map);
        this.state.featureOverlay.getSource().clear();
        this.setFotos({ layer: undefined, fotos: [] });
        fc.forEach((feature) => {
          this.state.featureOverlay.getSource().addFeature(feature);
        });
      });
      const extent = getFeaturesExtent(fc);
      zoomMapToBBOX(this.state.map, extent, false, true);
    }
  };

  apiZoomToBbox = (extent, epsg) => {
    if (!epsg) {
      epsg = config.EPSG;
    }
    extent = transformExtent(extent.map(Number), epsg, config.EPSG_mapa);
    zoomToBboxApi(extent, this.state.map);
  };

  changeLayerVisibility = (layerName, bool) => {
    const layer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    if (layer) {
      layer.setVisible(bool);
      bool ? layer.getOLLayer().setVisible(true) : layer.getOLLayer().setVisible(false);
    }
    this.setState({ updateLlegenda: !this.state.updateLlegenda });
  };

  zoomToCoordApi = async (coords, epsg, info) => {
    if (!epsg) {
      epsg = config.EPSG;
    }
    const coordsFormat = coords.map(Number);
    coords = transform(coordsFormat, epsg, config.EPSG_mapa);

    this.state.map.getView().setCenter(coords);
    this.state.map.getView().setResolution(0.5);

    if (info) {
      let layers = [];
      let extLayers = [];
      const map = this.state.map;
      map.once('rendercomplete', () => {
        let pixel = this.state.map.getPixelFromCoordinate(coords);
        pixel[0] = pixel[0].toFixed();
        pixel[1] = pixel[1].toFixed();
        if (displayComponents.infoCapa) {
          this.state.arrayLayers.forEach((layer) => {
            if (layer.isExternal()) extLayers.push(layer);
            let data = layer.getOLLayer().getData(pixel);
            if (data !== null && layer.hasInfoEnabled()) {
              layers.push(layer);
            }
          });

          if (extLayers.length > 0) {
            getFeatureInfoExternes(extLayers, this.state.map, this.state.mapHeight, this.state.mapWidth, pixel);
          }
        }
        this.onClickMap(layers, pixel, coords, [coords[0], coords[1]], false);
      });
    }
  };

  searchAddressApi = (search, infoPunt) => {
    goToLocation(this.addCercaToponim, this.clearArElements, this.onClickElementCerca, search, this.toggleLoadingLoc, infoPunt);
  };

  activateDraw = (tool) => {
    this.setState({ apiDraw: tool });
  };

  apiMeasure = (bool) => {
    this.toggleMedidas(bool);
  };

  disableDraw = () => {
    this.setState({ apiDraw: 'disable' });
    let vector = this.state.map
      .getInteractions()
      .getArray()
      .find(function (interaction) {
        return interaction.get('name') === 'vector';
      });
    let modify = this.state.map
      .getInteractions()
      .getArray()
      .filter(function (interaction) {
        return interaction.get('name') === 'vectorModify';
      });
    if (vector) {
      this.state.map.removeInteraction(vector);
      this.toggleDrawing(false);
    }
    if (modify) {
      modify.forEach((interaction) => {
        this.state.map.removeInteraction(interaction);
      });
    }
  };

  filterProcess = async (filterObj, zoom, table) => {
    let { layer, cond, geom, epsg, type, operator } = filterObj;
    if (!epsg) epsg = config.EPSG;
    const layerName = layer.getName();
    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    this.deleteTaula(layer);
    if (cond) {
      this.setApiTaulaConditions(layer, cond);
      const filter = CQLStringMaker(cond, operator, layer);
      this.setTaulaFilters(filter, layer);
    }

    let bbox;
    if (geom) {
      bbox = getBboxFilter(layer, type, geom, epsg);
      this.setTaulaSpacialBbox(layer, bbox);
    }

    await new Promise((resolve) => setTimeout(resolve, 200));
    let filterStr = '';
    if (bbox) {
      if (this.state.taulaFilters[layer.getTitle()]) {
        filterStr = `${bbox} AND  (${this.state.taulaFilters[layer.getTitle()]})`;
      } else {
        filterStr = bbox;
      }
    } else {
      filterStr = this.state.taulaFilters[layer.getTitle()];
    }

    await this.getTaulaArray(layer, undefined, undefined, bbox, table);
    this.state.map.removeLayer(layer.getOLLayer());
    await createLayer(layer, this.state.map, this.state.arrayLayers, false, layer.getStyle(layer.getStyleSelected()).getName(), filterStr);

    if (zoom) {
      let extent = layer.getBbox();
      if (layer.isExternal() === false) {
        if (this.state.taulaFullFilter[layer.getTitle()] !== undefined || !extent) {
          extent = await getLayerBboxWFS(this.state.taulaFullFilter[layer.getTitle()], layer);
        }
        zoomMapToBBOX(this.state.map, extent, this.state.alturaInfoPunt, true);
      }
    }
  };

  simpleFilter = async (filterOptions, zoom, table) => {
    await this.loadingCatalog();
    const { layerName, field, value, type, geom, epsg } = filterOptions;
    const layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
    if (layer) {
      let cond;
      if (field && value) {
        const fields = await getFeatureFields(layer);
        const fieldType = fields.filter((prop) => prop.field === field).type;
        const operator = fieldType !== 'text' ? "ILIKE 'value'" : '= value';
        cond = [{ field: field, operator: operator, value: value }];
      }
      const filterObject = { layer, cond, geom, epsg, type, operator: 'AND' };
      this.filterProcess(filterObject, zoom, table);
    }
  };

  advancedFilter = async (filterOptions, zoom, table) => {
    await this.loadingCatalog();

    const { layerName, filter, operator, type, geom, epsg } = filterOptions;
    const layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
    if (layer) {
      const filterObject = { layer, cond: filter, geom, epsg, type, operator };
      this.filterProcess(filterObject, zoom, table);
    }
  };

  apiReturnTable = async (layerName, page) => {
    await this.loadingCatalog();
    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    if (page) page = Number(page);

    const layer = this.state.arrayLayers.find((lay) => lay.getName() === layerName);
    if (!layer) return;
    const title = layer.getTitle();
    const pagination = this.state.taulaPage[title];
    if (pagination) {
      if (page === pagination || !page) {
        const message = {
          infoName: 'tableResult',
          data: this.tableMessage(layer)
        };
        window.parent.postMessage(message, getParentURL());
      } else {
        this.updateTablePage(page, layer);
        await this.getTaulaArray(layer, page, undefined, this.state.taulaSpacialBbox[title], false);
        const data = this.tableMessage(layer);

        const message = {
          infoName: 'tableResult',
          data: data
        };
        window.parent.postMessage(message, getParentURL());
      }
    } else {
      this.updateTablePage(page, layer);
      await this.getTaulaArray(layer, page, undefined, this.state.taulaSpacialBbox[title], false);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const data = this.tableMessage(layer);
      const message = {
        infoName: 'tableResult',
        data: data
      };
      window.parent.postMessage(message, getParentURL());
    }
  };

  tableMessage = (layer) => {
    const title = layer.getTitle();
    return {
      layer: layer.getName(),
      total: this.state.taulaTotal[title],
      page: this.state.taulaPage[title],
      filter: this.state.taulaFilters[title],
      geomFilter: this.state.taulaGeom[title],
      features: new GeoJSON().writeFeatures(this.state.taulaFc[title])
    };
  };

  startFeatureInsert = async (layerName, mode, geom, epsg, params) => {
    await this.loadingCatalog();

    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    const sitepLayer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    if (sitepLayer) {
      this.setState({ showEditCard: mode ? true : false, editCardProps: params ? params : undefined });
      this.setEditing('draw', sitepLayer, 'create');

      if (geom) {
        if (!epsg) {
          epsg = config.EPSG;
        }
        const geojsonFormat = new GeoJSON();
        const features = geojsonFormat.readFeatures(geom, {
          dataProjection: epsg,
          featureProjection: config.EPSG_mapa
        });
        makeGeomMulti(features);

        this.editSource.addFeatures(features);
      }
    }
  };

  drawCommitApi = async (properties) => {
    const layer = this.state.isEditing.layer;
    const source = this.editSource;
    const layerProps = properties;
    console.log(this.state.isEditing.type);
    if (this.state.isEditing.type === 'edit') {
      updateFeature(layer, source, source.getFeatures()[0], layerProps);
    } else {
      createFeature(layer, source, source.getFeatures()[0], layerProps);
    }
    this.setState({ showEditCard: true, editCardProps: undefined });

    this.stopEditing();
  };

  directInserction = async (layerName, properties, geom, epsg, loadLayer) => {
    await this.loadingCatalog();

    let layer;
    if (loadLayer) {
      await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
      layer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    } else {
      layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
    }
    const source = new VectorSource();

    if (!epsg) {
      epsg = config.EPSG;
    }
    const geojsonFormat = new GeoJSON();
    const features = geojsonFormat.readFeatures(geom, {
      dataProjection: epsg,
      featureProjection: config.EPSG_mapa
    });
    makeGeomMulti(features);
    source.addFeatures(features);

    createFeature(layer, source, source.getFeatures()[0], properties);
  };

  startFeatureEdit = async (layerName, featureId, mode, geom, epsg, params) => {
    await this.loadingCatalog();

    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    const sitepLayer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    let apiGeom;
    if (geom) {
      if (!epsg) {
        epsg = config.EPSG;
      }
      const geojsonFormat = new GeoJSON();
      const features = geojsonFormat.readFeatures(geom, {
        dataProjection: epsg,
        featureProjection: config.EPSG_mapa
      });
      makeGeomMulti(features);
      apiGeom = features;
    }

    if (sitepLayer && featureId) {
      const featureToEdit = await getFeatureById(sitepLayer, featureId);
      if (apiGeom) {
        apiGeom.forEach((feature) => {
          const properties = { ...featureToEdit.getProperties() };
          delete properties.geometry;
          feature.setProperties(properties);
          feature.setId(featureToEdit.getId());
        });
      }
      this.setState({ showEditCard: mode ? true : false, editCardProps: params ? params : undefined }, () => {
        this.setEditing(true, sitepLayer, 'edit', featureToEdit, apiGeom);
      });
    }
  };

  startDeletingGeometries = async (layerName, featureId) => {
    await this.loadingCatalog();

    await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
    const sitepLayer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    if (sitepLayer && featureId) {
      const featureToDelete = await getFeatureById(sitepLayer, featureId);
      if (featureToDelete && featureToDelete.getGeometry().getCoordinates().length > 1) {
        const extent = featureToDelete.getGeometry().getExtent();
        zoomMapToBBOX(this.state.map, extent, this.state.alturaInfoPunt);
        this.setState({ showEditCard: false, editCardProps: undefined }, () => {
          this.setEditing('deleteGeom', sitepLayer, 'deleteGeom', featureToDelete);
        });
      } else {
        toast.error(getTranslatedKey('deleteGeomError'));
      }
    }
  };

  directEdition = async (layerName, featureId, properties, geom, epsg, loadLayer) => {
    await this.loadingCatalog();
    let layer;
    if (loadLayer) {
      await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
      layer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    } else {
      layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
    }
    if (layer) {
      const featureToEdit = await getFeatureById(layer, featureId);
      let apiGeom = featureToEdit;
      if (geom) {
        if (!epsg) {
          epsg = config.EPSG;
        }
        const geojsonFormat = new GeoJSON();
        const features = geojsonFormat.readFeatures(geom, {
          dataProjection: epsg,
          featureProjection: config.EPSG_mapa
        });
        makeGeomMulti(features);

        features.forEach((feature) => {
          const properties = { ...featureToEdit.getProperties() };
          delete properties.geometry;
          feature.setProperties(properties);
          feature.setId(featureToEdit.getId());
        });
        apiGeom = features[0];
      }

      if (!epsg) {
        epsg = config.EPSG;
      }

      const featureProperties = properties
        ? properties
        : (() => {
            const props = { ...featureToEdit.getProperties() };
            delete props.geometry;
            return props;
          })();
      const source = new VectorSource().addFeatures(apiGeom);

      updateFeature(layer, source, apiGeom, featureProperties);
    }
  };

  directDeleteFeature = async (layerName, featureId, loadLayer) => {
    await this.loadingCatalog();
    let layer;

    if (loadLayer) {
      await loadLayers(layerName, this.state.map, this.state.sitepLayerInfoMap, this.state.arrayLayers, this.state.externalDefaultLayers, this);
      layer = this.state.arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
    } else {
      layer = this.state.sitepLayerInfoMap.find((sitepLayer) => sitepLayer.getName() === layerName);
    }
    if (layer) {
      const featureToDelete = await getFeatureById(layer, featureId);
      deleteFeature(layer, featureToDelete);
    }
  };

  validateApi = async (token) => {
    const permissions = await apiPermissions(token, this.props.id);
    if (permissions) {
      // toast.success('API Validada');

      const message = {
        infoName: 'isValidated',
        data: true
      };
      window.parent.postMessage(message, getParentURL());

      this.setState({
        apiEnabled: true,
        apiFunctions: {
          mapBbox: permissions.mapBbox,
          clickInfo: permissions.mapBbox,
          clickFeatures: permissions.clickFeatures,
          filterResult: permissions.filterResult,
          drawFeature: permissions.drawFeature
        }
      });

      // if (permissions.loadLayer) {
      //   window.loadLayer = this.loadLayersLlegenda;
      // }
      if (permissions.unloadLayer) {
        window.unloadLayer = this.unloadLayersLlegenda;
      }
      if (permissions.goToElementID) {
        window.goToElementID = this.goToElementByID;
      }
      if (permissions.goToElementFilter) {
        window.goToElementFilter = this.apiGoToElementByFilter;
      }
      if (permissions.zoomToBbox) {
        window.zoomToBbox = this.apiZoomToBbox;
      }
      if (permissions.zoomToCoord) {
        window.zoomToCoord = this.zoomToCoordApi;
      }
      if (permissions.changeLayerVisibility) {
        window.changeLayerVisibility = this.changeLayerVisibility;
      }
      if (permissions.searchAddress) {
        window.searchAddress = this.searchAddressApi;
      }
      if (permissions.activateDraw) {
        window.activateDraw = this.activateDraw;
      }
      if (permissions.disableDraw) {
        window.disableDraw = this.disableDraw;
      }
      if (permissions.toggleMeasures) {
        window.toggleMeasures = this.apiMeasure;
      }
      if (permissions.simpleFilter) {
        window.simpleFilter = this.simpleFilter;
      }
      if (permissions.advancedFilter) {
        window.advancedFilter = this.advancedFilter;
      }
      if (permissions.getTable) {
        window.getTable = this.apiReturnTable;
      }
      if (permissions.drawNewElement) {
        window.drawNewElement = this.startFeatureInsert;
      }
      if (permissions.cancelEdition) {
        window.cancelEdition = this.stopEditing;
      }
      if (permissions.insertNewElement) {
        window.insertNewElement = this.directInserction;
      }
      if (permissions.drawEditElement) {
        window.drawEditElement = this.startFeatureEdit;
      }
      if (permissions.drawCommit) {
        window.drawCommit = this.drawCommitApi;
      }
      if (permissions.deleteGeometries) {
        window.deleteGeometries = this.startDeletingGeometries;
      }
      if (permissions.deleteElement) {
        window.deleteElement = this.directDeleteFeature;
      }
      if (permissions.updateElement) {
        window.updateElement = this.directEdition;
      }
    } else {
      const message = {
        infoName: 'isValidated',
        data: false
      };
      window.parent.postMessage(message, getParentURL());
    }
  };

  ApiInitiator = async () => {
    window.addEventListener(
      'message',
      (event) => {
        const expectedOrigin = getParentURL();
        if (event.origin !== expectedOrigin) {
          console.warn('Received message from unexpected origin:', event.origin);
          return;
        }

        const data = event.data;
        const functionName = data.functionName;
        const parameters = data.parameters;
        if (typeof window[functionName] === 'function') {
          window[functionName](...parameters);
        }
      },
      false
    );

    window.search = this.apiSearch;
    window.loadLayer = this.loadLayersLlegenda;
    window.loadContextCollectionMap = this.loadMapById;
    window.validateApi = this.validateApi;
    //Añadir a API validator
  };

  /**
   *
   * @desc Funcion encargada de llamar a solr y buscar coincidencias en la busqueda
   * @param {*} search
   */
  cercaSolr = async (search) => {
    search = solrTextFormat(search);
    let self = this;
    while (this.state.sitepLayerInfoMap.length === 0) {
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    let layers = this.state.sitepLayerInfoMap
      .filter((layer) => !layer.isExternal() && layer.getExtension().Searchable)
      .map((layer) => layer.getName());
    // let layers = this.state.sitepLayerInfoMap.filter((layer) => !layer.isExternal()).map((layer) => layer.getName());
    if (layers.length === 0) {
      this.setState({ isLoadingEle: false });

      return;
    }
    let searchRequest = {
      q: search,
      continguts: layers,
      limit: 100,
      offset: 0,
      field: 'Cerca'
    };

    let $request = this.state.requestSolr;
    if ($request != null) {
      $request.abort();
      this.setState({ requestSolr: null });
    }

    //PRE
    // let url = config.url_solrPRE;

    //PRO
    let url = config.url_solrPRO;

    $request = $j.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify(searchRequest),
      contentType: 'application/json; charset="utf-8"',
      dataType: 'json',
      cache: false,
      success: function (data) {
        self.arSolr = data;
      },
      error: function () {},
      complete: function () {
        this.setState({ isLoadingEle: false });
      }.bind(this)
    });
    this.setState({ requestSolr: $request });
  };

  /**
   * @desc Función encargada de buscar en el catalogo las capas coincidentes con la cerca
   */
  cercaCataleg = async (search) => {
    this.cercaText = search;
    while (!this.state.catalogData) {
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    if (this.state.catalogData !== undefined) {
      let resultats = [];
      this.cercaLayersCataleg(this.state.catalogData.LayerList.Layer, undefined, this.cercaText, resultats);
      this.arCapesCataleg = resultats;
      this.setState({ isLoadingCapa: false });

      //this.setState({ arCapesCataleg: resultats });
    }
  };

  /**
   * @param {*} layer
   * @param {*} parent
   * @param {*} search
   * @desc Función recursiva para encontrar todas las capas padres e hijas coincidentes con la cerca
   */
  cercaLayersCataleg = (layer, parent, search, resultats) => {
    layer.forEach((capa) => {
      if (!capa.Name.includes('WMS ')) {
        if (normalizeText(capa.Title).includes(normalizeText(search))) {
          if (parent !== undefined) {
            capa.Parent = parent;
            if (parent.Breadcrumb === undefined) {
              capa.Breadcrumb = parent.Title;
            } else {
              capa.Breadcrumb = parent.Breadcrumb + ' > ' + parent.Title;
            }
          }
          resultats.unshift(capa);
        }
        if (
          (normalizeText(capa.Name).includes(normalizeText(search)) || normalizeText(capa.Abstract).includes(normalizeText(search))) &&
          !normalizeText(capa.Title).includes(normalizeText(search))
        ) {
          if (parent !== undefined) {
            capa.Parent = parent;
            if (parent.Breadcrumb === undefined) {
              capa.Breadcrumb = parent.Title;
            } else {
              capa.Breadcrumb = parent.Breadcrumb + ' > ' + parent.Title;
            }
          }
          resultats.push(capa);
        }
        if (capa.Layer !== undefined && capa.Layer !== '' && capa.Layer !== null) {
          resultats.concat(this.cercaLayersCataleg(capa.Layer, capa, search, resultats));
        }
      }
    });
  };

  /**
   * @desc Función encargada de limpiar las variables cuando se produce una búsqueda vacía
   */
  handleCercaBuida = () => {
    this.arElements = [];
    this.arCapesCataleg = [];
    this.arSolr = [];
    this.setState({ cercaOpen: null }, () => this.setState({ cercaOpen: false }));
  };

  /**
   * @desc Función encargada de añadir un nuevo toponimo al estado de la pàgina
   */
  addCercaToponim = async (toponim) => {
    this.setState({ cercaPrevia: null }, () => this.setState({ cercaPrevia: '' })); // TODO esto es para actualizar el estado y que se renderice
    toponim.isToponim = true;
    this.arElements.push(toponim);
    this.setState({ isLoadingLoc: false });
  };

  /**
   * @desc Función encargada de limpiar la lista de elementos de la cerca
   */
  clearArElements = () => {
    this.arElements = [];
    //this.setState({ arElements: [] });
  };

  /**
   * @desc Función encargada de añadir un nuevo elemento de las capas del catalogo del icgc al estado de la pàgina
   */
  addCercaElementCataleg = (elemCataleg) => {
    elemCataleg.isToponim = false;
    this.arElements.push(elemCataleg);
    //this.state.arElements.push(elemCataleg);
  };

  /**
   * @desc funcion para obtener el ID del catalogo
   */
  getCatalogID = async () => {
    let url = config.url_getCatalogID;
    let catalogResponse = await fetch(url);
    let catalogID = await catalogResponse.json();
    return catalogID;
  };

  fillLayerState = (layer) => {
    if (layer.hasOwnProperty('Layer')) {
      for (let i in layer.Layer) {
        this.fillLayerState(layer.Layer[i]);
      }
    } else {
      const newLayer = new Layer(layer, false, false);
      this.state.sitepLayerInfoMap.push(newLayer);
    }
  };

  /**
   *
   * @desc función que se llama al obtener una respuesta en la llamada de obtener el catálogo y actualiza el estado de la variable catalogData
   */
  displayCatalogData = async () => {
    //obtenemos el catalogo de capas oficial
    this.getCatalog().then((data) => {
      data.LayerList.Layer.forEach((layer) => {
        if (!layer.Name.includes('WMS ')) {
          var sitepLayer = new Layer(layer, false, false);
          this.state.sitepLayerMap.push(sitepLayer);
          this.fillLayerState(layer);
        }
      });
      this.setState({ catalogData: data });
    });

    // obtenemos el catalogo de capas externas
    var xhttp = new XMLHttpRequest();
    xhttp.open('GET', config.url_extenal, false);

    xhttp.send();
    var xmlDoc = xhttp.responseXML;
    var externalLayersJson = xmlToJson(xmlDoc);

    Object.keys(externalLayersJson).length !== 0 &&
      externalLayersJson.ViewContext.LayerList.Layer.forEach((layer, index) => {
        var sitepLayer = new Layer(layer, true, false);
        this.state.externalDefaultLayers.push(sitepLayer);
      });
  };

  /**
   *
   * @desc función que hace la llamada al backend para obtener el catálogo
   */
  //PRE
  getCatalog = async () => {
    let id;
    if (this.props.visor) {
      if (!this.props.visor.idCat) {
        id = '';
      } else {
        id = this.props.visor.idCat;
      }
    } else {
      id = await this.getCatalogID();
    }

    // INTRANET
    let url = config.url_getCatalogUser + id;
    let catalogResponse;

    try {
      catalogResponse = await axios.get(url);
      this.setState({ loading: false });
    } catch (error) {
      try {
        url = config.url_getCatalog + id;
        catalogResponse = await axios.get(url);
        this.setState({ loading: false });
      } catch (e) {
        setTimeout(() => {
          this.displayCatalogData();
        }, 3e4);
      }
    }

    let catalogJSON = catalogResponse.data;
    return catalogJSON;
  };

  //DVP
  // getCatalog = async () => {
  //   let id;
  //   if (this.props.visor) {
  //     if (!this.props.visor.idCat) {
  //       id = '';
  //     } else {
  //       id = this.props.visor.idCat;
  //     }
  //   } else {
  //     id = await this.getCatalogID();
  //   }

  //   // INTRANET
  //   //let url = config.url_getCatalogUser + id;
  //   let url = config.url_getCatalog + id;
  //   let catalogResponse;

  //   try {
  //     catalogResponse = await axios.get(url);
  //     this.setState({ loading: false });
  //   } catch (error) {
  //     try {
  //       //url = config.url_getCatalog + id;
  //       catalogResponse = await axios.get(url);
  //       this.setState({ loading: false });
  //     } catch (error) {
  //       setTimeout(() => {
  //         this.displayCatalogData();
  //       }, 3e4);
  //     }
  //   }

  //   let catalogJSON = catalogResponse.data;
  //   return catalogJSON;
  // };

  /**
   * @param {*} capa
   * @desc Función encargada de añadir una capa a la leyenda
   */
  addLayerToLlegenda = async (capa) => {
    await this.addLayerToLlegendaRecursive(capa);
    this.setState({ cercaOpen: false });
  };

  toggleDrawing = (bool) => {
    this.setState({ isDrawing: bool });
  };

  toggleSelecting = (bool, layer) => {
    this.setState({ isSelecting: [bool, layer] });
  };

  /**
   * @param {*} capa
   * @desc Función recursiva encargada de añadir una capa a la leyenda
   */
  addLayerToLlegendaRecursive = async (capa) => {
    if (capa.Layer !== undefined && capa.Layer !== null) {
      // solo queremos que se añadan a la leyenda las hojas
      for (let i = 0; i < capa.Layer.length; ++i) {
        this.addLayerToLlegendaRecursive(capa.Layer[i]);
      }
    } else {
      delete capa.Parent;
      if (this.state.arrayLayers.findIndex((object) => object.getName() === capa.Name) === -1) {
        // añadimos la hoja si no está repetida
        let capaFormatejada = new Layer(capa, false, false);

        var tileGrid = createXYZ({
          extent: transformExtent([258000, 4485000, 536000, 4752000], config.EPSG, config.EPSG_mapa),
          tileSize: 512
        });
        let url = capaFormatejada.getOnlineResource();

        let sourceWMS = new TileWMS({
          url: url,
          params: {
            LAYERS: capaFormatejada.getName(),
            TRANSPARENT: true,
            SERVICE: 'WMS',
            VERSION: config.capabilities_version,
            SRS: config.EPSG_mapa,
            WIDTH: 512,
            HEIGHT: 512,
            TILED: true,
            FORMAT_OPTIONS: 'dpi:72'
          },
          serverType: 'geoserver',
          tileGrid: tileGrid
        });

        let sitepLayer = new TileLayer({
          source: sourceWMS
        });

        sourceWMS.on('tileloadstart', function (event) {
          event.tile.getImage().addEventListener('error', function (error) {
            capaFormatejada.setError(true);
          });
        });

        capaFormatejada.setOLLayer(sitepLayer);
        this.state.arrayLayers.unshift(capaFormatejada);
        this.state.map.addLayer(capaFormatejada.getOLLayer());
      }
    }
  };

  /**
   * @param {*} isOpen
   * @desc Función encargada de cambiar el estado abierto / cerrado de la leyenda
   */
  changeLlegendaOpen = (isOpen) => {
    this.setState({ llegendaOpen: isOpen });
    if (window.innerWidth < 768 && (this.state.infoPuntObert || this.state.taulaCapaObert)) {
      this.setState({ alturaInfoPunt: (window.innerHeight - 40) / 3 });
      this.onResizeInfoPuntCard((window.innerHeight - 40) / 3);
    }
    if (isOpen === true) {
      this.setState({ catalogOpen: false }, () => {
        this.memoria(false);
      });
    }
  };

  handleCercaAvançadaOpen = (isOpen) => {
    if (isOpen) {
      this.setState({ cercaOpen: false, catalogOpen: false });
    }
    this.setState({ cercaAvançada: isOpen, mapSelectOpen: false }, () => {
      this.memoria(this.state.cercaAvançada);
    });
  };

  /**
   * @desc Función encargada de cambiar el estado abierto / cerrado del pop-up de inicio
   */

  toggleModal = () => {
    this.setState({ modalIniciOpen: !this.state.modalIniciOpen });
  };

  /**
   * @desc Función encargada de cambiar el estado abierto / cerrado del modal de compartir
   */

  toggleShare = (to, close) => {
    let action = to === this.state.modalShareKind && this.state.modalShareOpen ? false : true;

    if (to === 'print') {
      let vector = this.state.map
        .getInteractions()
        .getArray()
        .find(function (interaction) {
          return interaction.get('name') === 'vector';
        });
      if (vector) {
        this.state.map.removeInteraction(vector);
      }
      let filter = this.state.map
        .getInteractions()
        .getArray()
        .find(function (interaction) {
          return interaction.get('name') === 'filter';
        });

      if (filter) {
        this.state.map.removeInteraction(filter);
      }

      this.setState({ cercaOpen: false, cercaAvançada: false, catalogOpen: false }, () => {
        this.memoria(false);
      });
    } else if (to === 'share') {
      this.setState({ cercaOpen: false, cercaAvançada: false, catalogOpen: false }, () => {
        this.memoria(false);
      });
    }

    if (close === true) {
      action = false;
    }

    this.setState({ modalShareOpen: action, modalShareKind: to });
  };

  /**
   * @desc Función encargada de cambiar el estado abierto / cerrado de la ayuda
   */
  toggleAjuda = () => {
    this.setState(
      {
        ajudaOpen: !this.state.ajudaOpen,
        infoPuntObert: false,
        displayInfoPuntBody: false,
        catalogOpen: false,
        llegendaOpen: false,
        infoOpenAccess: false,
        infoOpenCookies: false,
        cercaOpen: false,
        cercaAvançada: false,
        taulaCapaObert: false,
        modalShareOpen: false,
        galeriaOpen: false
      },
      async () => {
        this.toggleMapSelector(false);
        this.onResizeInfoPuntCard(0);
        await esborrarXinxeta(this.state.map);
        this.state.featureOverlay.getSource().clear();
      }
    );
  };

  /**
   * @desc funcion para cambiar el estado on / off del tamaño de letra de accesibilidad
   */
  toggleFontSize = () => {
    this.setState({ fontSizeEnabled: !this.state.fontSizeEnabled });
  };

  /**
   * @desc Función encargada de cambiar el estado abierto / cerrado del modal de inicio
   */
  toggleError = () => {
    this.setState({ modalErrorOpen: !this.state.modalErrorOpen });
  };

  /**
   * @desc Función encargada de cambiar el estado abierto / cerrado de la pantalla de informacion de accesibilidad
   */
  toggleInfoAccessibilitat = () => {
    this.setState({ infoOpenAccess: !this.state.infoOpenAccess });
  };

  /**
   * @desc Función encargada de cambiar el estado abierto / cerrado de la pantalla de informacion de cookies
   */
  toggleInfoCookies = () => {
    this.setState({ infoOpenCookies: !this.state.infoOpenCookies });
  };
  /**
   * @desc Función encargada de cerrar la pantalla de informacion
   */
  closeInfo = () => {
    this.setState({ infoOpenCookies: false });
    this.setState({ infoOpenAccess: false });
  };

  //FUNCIONES DE LA TABLA DE DATOS
  /**
   * @desc Función encargada de pedir la tabla de datos
   */
  getTaulaArray = async (layer, page, sortBy, bbox, taula = true) => {
    let layerTitle = layer.getTitle();
    this.setState({ taulaLayer: layer, taulaLoading: { [layerTitle]: true } });
    let response;
    let identificador = layer.getExtension().Id;
    let newTaulaArr = [];
    let taulaFilter = this.state.taulaFilters[layerTitle];
    let selected = this.state.selectedArray[layerTitle];
    let stringSegment = '';
    let filter = '';
    const altura = window.innerHeight < 700 ? (window.innerHeight - 40) / 2.5 : (window.innerHeight - 40) / 3;

    if (taula) {
      if (!this.state.taulaCapaObert && displayComponents.taulaDadesCapa) {
        if (!this.state.infoPuntObert) {
          this.setState({ alturaInfoPunt: altura });
          this.onResizeInfoPuntCard(altura);
        }
        this.setState({
          taulaCapaObert: true,
          infoPuntObert: false,
          thumbnailsOpen: false,
          statsOpen: false,
          alturaInfoPunt: altura
        });
        this.onResizeInfoPuntCard(altura);
      }
    }
    this.setState((prevState) => ({
      taulaArray: {
        ...prevState.taulaArray,
        [layerTitle]: []
      }
    }));
    if (taulaFilter !== undefined || bbox || selected) {
      if (bbox) {
        if (taulaFilter && taulaFilter !== '') {
          filter = `${bbox} AND  (${taulaFilter})`;
        } else {
          filter = bbox;
        }
      } else if (selected && selected.length > 0) {
        selected.forEach((ID) => {
          if (stringSegment === '') {
            stringSegment = `${identificador} = ${ID}`;
          } else {
            stringSegment = stringSegment + ` OR ${identificador} = ${ID}`;
          }
        });
        filter = stringSegment;
      } else {
        filter = taulaFilter;
      }
    }
    this.setFullFilter(layer, filter);
    response = await getFeatureByFilter(layer, filter, page, sortBy);
    let total = response?.totalFeatures;
    if (!total) {
      total = await getTableHits(layer, filter);
    }
    if (response !== 'error') {
      this.setState((prevState) => ({
        taulaTotal: {
          ...prevState.taulaTotal,
          [layerTitle]: total
        }
      }));
      let fc = new GeoJSON().readFeatures(response);
      if ((filter || this.state.taulaFc[layerTitle]) && this.state.apiEnabled && this.state.apiFunctions.filterResult) {
        const message = {
          infoName: 'tableResult',
          data: {
            layer: layer.getName(),
            total: total,
            page: page,
            filter: taulaFilter,
            geomFilter: this.state.taulaGeom[layerTitle],
            features: new GeoJSON().writeFeatures(fc)
          }
        };
        window.parent.postMessage(message, getParentURL());
      }
      this.setState((prevState) => ({
        taulaFc: {
          ...prevState.taulaFc,
          [layerTitle]: fc
        }
      }));

      response.features.forEach((feature) => {
        let newObj = {};

        for (const key in feature.properties) {
          if (key !== identificador) {
            newObj[key] = feature.properties[key];
          }
        }
        newTaulaArr.push(newObj);
        this.setState((prevState) => ({
          taulaArray: {
            ...prevState.taulaArray,
            [layerTitle]: newTaulaArr
          }
        }));
      });
    }
    this.setState((prevState) => {
      const updatedLoadingArr = { ...prevState.taulaLoading };
      delete updatedLoadingArr[layerTitle];
      return {
        taulaLoading: updatedLoadingArr
      };
    });
  };

  /**
   * @desc Función encargada de generar tabla de datos para archivos externos
   */
  getExternTable = (layer, page) => {
    let features = layer.getOLLayer().getSource().getFeatures();
    let total = features.length;
    if (page) {
      const startIndex = page * 20;
      const endIndex = startIndex + 20;
      features = features.slice(startIndex, endIndex);
    } else {
      features = features.slice(0, 20);
    }
    let properties = [];
    features.forEach((feat) => {
      let props = feat.getProperties();
      delete props.geometry;
      properties.push(props);
    });
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaTotal: {
        ...prevState.taulaArray,
        [layerTitle]: total
      },

      taulaArray: {
        ...prevState.taulaArray,
        [layerTitle]: properties
      },
      taulaFc: {
        ...prevState.taulaFc,
        [layerTitle]: features
      }
    }));
    this.setTaulaLayer(layer);
  };

  setFullFilter = (layer, filter) => {
    let layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaFullFilter: {
        ...prevState.taulaFullFilter,
        [layerTitle]: filter
      }
    }));
  };

  updateTablePage = (num, layer) => {
    let layerTitle = layer.getTitle();

    this.setState((prevState) => ({
      taulaPage: {
        ...prevState.taulaPage,
        [layerTitle]: num
      }
    }));
  };

  setTaulaFilters = (filters, layer) => {
    let layerTitle = layer.getTitle();

    this.setState((prevState) => ({
      taulaFilters: {
        ...prevState.taulaFilters,
        [layerTitle]: filters
      }
    }));
  };

  setTaulaSorting = (sorting, layer) => {
    let layerTitle = layer.getTitle();

    this.setState((prevState) => ({
      taulaSorting: {
        ...prevState.taulaSorting,
        [layerTitle]: sorting
      }
    }));
  };

  setTaulaLayer = (layer) => {
    this.setState({
      taulaLayer: layer,
      taulaCapaObert: true,
      infoPuntObert: false,
      thumbnailsOpen: false,
      statsOpen: false
    });
    if (this.state.alturaInfoPunt === 0) {
      this.setState({ alturaInfoPunt: (window.innerHeight - 40) / 3 });
      this.onResizeInfoPuntCard((window.innerHeight - 40) / 3);
    }
  };

  setTaulaConditions = (layer, conditions) => {
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaConditions: {
        ...prevState.taulaConditions,
        [layerTitle]: conditions
      }
    }));
  };
  setApiTaulaConditions = (layer, conditions) => {
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaApiConditions: {
        ...prevState.taulaApiConditions,
        [layerTitle]: conditions
      }
    }));
  };

  setTaulaResp = (layer, resp) => {
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaResp: {
        ...prevState.taulaResp,
        [layerTitle]: resp
      }
    }));
  };

  setTaulaGeom = (layer, geom) => {
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaGeom: {
        ...prevState.taulaResp,
        [layerTitle]: geom
      }
    }));
  };

  /**
   * @desc Función encargada definir el filtro espacial utilizado en el filtraje
   */
  setTaulaSpacialFilter = (layer, filter) => {
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaSpacialFilter: {
        ...prevState.taulaSpacialFilter,
        [layerTitle]: filter
      }
    }));
  };

  /**
   * @desc Función encargada definir la bbox del filtro
   */
  setTaulaSpacialBbox = (layer, bbox) => {
    const layerTitle = layer.getTitle();
    this.setState((prevState) => ({
      taulaSpacialBbox: {
        ...prevState.taulaSpacialBbox,
        [layerTitle]: bbox
      }
    }));
  };

  getSelectedFeatures = async (layer, pixel) => {
    let identificador = layer.getExtension().Id;
    let layerTitle = layer.getTitle();
    let stylesList = '';
    let url = layer.getOnlineResource();

    let ext = this.state.map.getView().calculateExtent(this.state.map.getSize());
    let bbox = ext[0] + ',' + ext[1] + ',' + ext[2] + ',' + ext[3];

    let style = layer.getCurrentStyle().getName();

    stylesList += stylesList === '' ? (style !== undefined ? style : ',') : style !== undefined ? ',' + style : ',';

    url += '?LAYERS=' + layer.getName() + '&QUERY_LAYERS=' + layer.getName() + '&STYLES=';
    if (stylesList !== undefined) url += stylesList;
    url += '&SERVICE=WMS&VERSION=' + config.capabilities_version + '&REQUEST=GetFeatureInfo&BBOX=' + bbox;

    let buffer = 5;
    if (window.innerWidth <= 768) buffer = 15;

    url +=
      '&FEATURE_COUNT=1' +
      '&HEIGHT=' +
      this.state.mapHeight.split('px')[0] +
      '&WIDTH=' +
      this.state.mapWidth.split('px')[0] +
      '&FORMAT=image%2Fpng&INFO_FORMAT=application/json&CRS=' +
      config.EPSG_mapa;
    url += '&X=' + pixel[0] + '&Y=' + pixel[1] + '&buffer=' + buffer;

    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=Windows-1252',
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(async (resp) => {
        let parsed = await resp.clone().json();

        this.setState((prevState) => {
          if (this.state.selectedArray[layerTitle] !== undefined) {
            const newArr = [...prevState.selectedArray[layerTitle]];
            const index = newArr.findIndex((id) => id === parsed.features[0].properties[identificador]);
            if (index === -1) {
              newArr.push(parsed.features[0].properties[identificador]);
            } else {
              newArr.splice(index, 1);
            }

            return {
              selectedArray: {
                ...prevState.selectedArray,
                [layerTitle]: newArr
              }
            };
          } else {
            return {
              selectedArray: {
                ...prevState.selectedArray,
                [layerTitle]: [parsed.features[0].properties[identificador]]
              }
            };
          }
        });

        return resp.text();
      })
      .then(async (data) => {
        // Para la feature collection
        var feature = new GeoJSON().readFeatures(data);
        feature = feature[0];
        if (feature.values_[identificador]) {
          this.setState(
            (prevState) => {
              if (this.state.selectedFeatures[layerTitle] !== undefined) {
                const newArr = [...prevState.selectedFeatures[layerTitle]];
                const index = newArr.findIndex((obj) => obj.values_[identificador] === feature.values_[identificador]);

                if (index === -1) {
                  newArr.push(feature);
                } else {
                  newArr.splice(index, 1);
                }
                return {
                  selectedFeatures: {
                    ...prevState.selectedFeatures,
                    [layerTitle]: newArr
                  }
                };
              } else {
                return {
                  selectedFeatures: {
                    ...prevState.selectedFeatures,
                    [layerTitle]: [feature]
                  }
                };
              }
            },
            () => {
              this.selectVector.getSource().clear();
              this.state.selectedFeatures[layerTitle].forEach((ft) => {
                this.selectVector.getSource().addFeature(ft);
              });
            }
          );
        }
      })

      .catch(async (err) => {
        // toast.error(getTranslatedKey('error_obtainFeatures'));
      });
  };

  deleteTaula = (layer, fromTab) => {
    if (layer === 'all') {
      this.onClickInfoPunt('close');
      this.setState({
        selectedArray: {},
        selectedFeatures: {},
        taulaFilters: {},
        taulaArray: {},
        taulaFc: {},
        taulaConditions: {},
        taulaResp: {},
        taulaGeom: {},
        taulaSpacialFilter: {},
        taulaFullFilter: {},
        taulaSpacialBbox: {},
        taulaSorting: {}
      });
      return;
    }
    let title = layer.getTitle();

    if (this.state.taulaLayer !== null) {
      let newArr = Object.keys(this.state.taulaArray);
      let index = newArr.findIndex((key) => key === title);

      newArr.splice(index, 1);
      this.state.arrayLayers.forEach((loadedLayer) => {
        if (loadedLayer.getTitle() === (index === newArr.length ? newArr[index - 1] : newArr[index])) {
          this.setState({ taulaLayer: loadedLayer });
        }
      });
    }

    this.setState((prevState) => {
      const updatedSelectedArr = { ...prevState.selectedArray };
      const updatedSelectedFeatures = { ...prevState.selectedFeatures };
      const updatedTaulaFiltersArr = { ...prevState.taulaFilters };
      const updatedTaulaArr = { ...prevState.taulaArray };
      const updatedTaulaFcArr = { ...prevState.taulaFc };
      const updatedTaulaConditions = { ...prevState.taulaConditions };
      const updatedTaulaResp = { ...prevState.taulaResp };
      const updatedTaulaSpacialFilter = { ...prevState.taulaSpacialFilter };
      const updatedTaulaFullFilter = { ...prevState.taulaFullFilter };
      const updatedTaulaGeom = { ...prevState.taulaGeom };
      const updatedTaulaSpacialBbox = { ...prevState.taulaSpacialBbox };
      const updatedTaulaSorting = { ...prevState.taulaSorting };
      if (fromTab) {
        delete updatedTaulaArr[title];
      } else {
        delete updatedTaulaSpacialBbox[title];
        delete updatedTaulaResp[title];
        delete updatedTaulaConditions[title];
        delete updatedTaulaFiltersArr[title];
        delete updatedSelectedArr[title];
        delete updatedSelectedFeatures[title];
        delete updatedTaulaArr[title];
        delete updatedTaulaFcArr[title];
        delete updatedTaulaSpacialFilter[title];
        delete updatedTaulaFullFilter[title];
        delete updatedTaulaGeom[title];
        delete updatedTaulaSorting[title];
      }

      return {
        selectedArray: updatedSelectedArr,
        selectedFeatures: updatedSelectedFeatures,
        taulaFilters: updatedTaulaFiltersArr,
        taulaArray: updatedTaulaArr,
        taulaFc: updatedTaulaFcArr,
        taulaConditions: updatedTaulaConditions,
        taulaResp: updatedTaulaResp,
        taulaSpacialFilter: updatedTaulaSpacialFilter,
        taulaFullFilter: updatedTaulaFullFilter,
        taulaSpacialBbox: updatedTaulaSpacialBbox,
        taulaBbox: updatedTaulaGeom,
        taulaSorting: updatedTaulaSorting
      };
    });
  };

  resetSelected = (layer, clear) => {
    this.setState({
      isSelecting: [false, null],
      selectedArray: {},
      selectedFeatures: {}
    });
    this.selectVector.getSource().clear();

    if (clear) {
      this.setState((prevState) => {
        const updatedTaulaConditions = { ...prevState.taulaConditions };
        const updatedTaulaFiltersArr = { ...prevState.taulaFilters };
        const updatedTaulaSpacialBbox = { ...prevState.taulaSpacialBbox };

        delete updatedTaulaFiltersArr[layer.getTitle()];
        delete updatedTaulaConditions[layer.getTitle()];
        delete updatedTaulaSpacialBbox[layer.getTitle()];

        return {
          taulaFilters: updatedTaulaFiltersArr,
          taulaConditions: updatedTaulaConditions,
          taulaSpacialBbox: updatedTaulaSpacialBbox
        };
      });
    }
  };

  /**
   * @desc Función encargada de gestionar el cambio de pestaña en la pantalla de información
   */
  tableInfoToggle = (to) => {
    if (to === 'table' && Object.keys(this.state.taulaArray).length > 0) {
      this.setState({
        taulaCapaObert: true,
        infoPuntObert: false,
        thumbnailsOpen: false,
        statsOpen: false
      });
    } else if (to === 'info' && this.state.clickCoords) {
      this.setState({
        taulaCapaObert: false,
        infoPuntObert: true,
        thumbnailsOpen: false,
        statsOpen: false
      });
    } else if (to === 'thumbnails' && this.state.galeria.fotos.length > 0) {
      this.setState({
        thumbnailsOpen: true,
        taulaCapaObert: false,
        infoPuntObert: false,
        statsOpen: false
      });
    } else if (to === 'stats') {
      this.setState({
        thumbnailsOpen: false,
        taulaCapaObert: false,
        infoPuntObert: false,
        statsOpen: true
      });
    } else {
      this.onResizeInfoPuntCard(0);
    }
  };

  /**
   * @desc Función encargada de gestionar el cierre de la ventana de información
   */
  closeInfoPunt = (e) => {
    if (e) e.stopPropagation();
    this.setState({ infoPuntObert: false, infoPuntInfo: null, clickCoords: null }, async () => {
      await esborrarXinxeta(this.state.map);
      this.state.featureOverlay.getSource().clear();
      this.setFotos({ layer: undefined, fotos: [] });
    });
  };

  /**
   * @desc Función encargada de gestionar el cierre de una tabla
   */
  closeTable = (title, e) => {
    if (Object.keys(this.state.taulaArray).length === 1) {
      this.closeAllTabs(e);
    } else {
      this.state.arrayLayers.forEach((layer) => {
        if (layer.getTitle() === title) {
          this.deleteTaula(layer, true);
        }
      });
    }
  };

  /**
   * @desc Función encargada de gestionar el cierre de la pestaña de tabla
   */
  closeAllTabs = (e) => {
    e.stopPropagation();
    if (this.state.clickCoords) {
      this.tableInfoToggle('info');
    } else if (this.state.galeria.fotos.length > 0 && window.innerWidth > 768) {
      this.tableInfoToggle('thumbnails');
    } else if (this.state.statsLayer) {
      this.tableInfoToggle('stats');
    } else {
      this.setState({ taulaCapaObert: false });
      this.onResizeInfoPuntCard(0);
    }
    this.state.arrayLayers.forEach((layer) => {
      this.deleteTaula(layer, true);
    });
  };

  /**
   * @desc Función encargada de gestionar el cierre de la pestaña de imágenes
   */
  closeThumbnails = (e) => {
    if (e) {
      e.stopPropagation();
    }
    this.setState({ galeria: { layer: undefined, fotos: [] } });
    this.tableInfoToggle('info');
  };

  /**
   * @desc Función encargada de gestionar el cierre de la pestaña de información
   */
  closeInfoTab = (e) => {
    e.stopPropagation();
    if (Object.keys(this.state.taulaArray)?.length > 0) {
      this.tableInfoToggle('table');
      this.closeInfoPunt(e);
    } else if (this.state.statsLayer) {
      this.tableInfoToggle('stats');
      this.closeInfoPunt(e);
    } else {
      this.onClickInfoPunt('close', e);
      this.setFotos({ layer: undefined, fotos: [] });
    }
  };

  /**
   * @desc Función encargada de gestionar el cierre de la pestaña de información
   */
  closeStatsTab = (e) => {
    if (e) {
      e.stopPropagation();
    }
    this.setState({ statsLayer: undefined }, () => {
      if (Object.keys(this.state.taulaArray)?.length > 0) {
        this.tableInfoToggle('table');
        this.closeInfoPunt(e);
      } else if (this.state.clickCoords) {
        this.tableInfoToggle('info');
      } else {
        this.onClickInfoPunt('close', e);
      }
    });
  };

  /**
   * @desc Función encargada de definir las fotos que se ven en la galeria
   */
  setFotos = (obj) => {
    this.setState({ galeria: obj });
  };

  /**
   * @desc Función encargada de abrir o cerrar el slider de imagenes
   */
  toggleGaleria = (bool, index) => {
    if (index !== undefined) {
      this.setState({ galeriaIndex: index });
    }
    this.setState({ galeriaOpen: bool });
  };

  /**
   * @desc Función encargada de abrir o cerrar el selector de mapas
   */
  toggleMapSelector = (bool) => {
    if (bool === true && window.innerWidth < 520 + 480 + 20) {
      this.setState({ catalogOpen: false, favOpen: false });
    }

    this.setState({ mapSelectOpen: bool, favOpen: false });
  };

  /**
   * @desc Función encargada de guardar el estado de la ventana de información y de la leyenda para ocultarlo/mostrarlo cuando se abra el catálogo o las búsquedas
   */
  memoria = (action, cat) => {
    if (action === true) {
      if (this.state.llegendaOpen === true && !this.state.hadLlegenda) {
        this.setState({ hadLlegenda: true, llegendaOpen: false });
      }
      if (!cat) {
        if ((this.state.infoPuntObert || this.state.taulaCapaObert || this.state.thumbnailsOpen || this.state.statsOpen) && !this.state.hadLlegenda) {
          this.setState({ hadInfoPannel: true });
        }
        if (this.state.infoPuntObert || this.state.taulaCapaObert || this.state.thumbnailsOpen || this.state.statsOpen) {
          if (!this.state.hadAltura) {
            this.setState({ hadAltura: this.state.alturaInfoPunt });
          }
          this.onResizeInfoPuntCard(35);
        }
      }
    } else {
      if (!this.state.catalogOpen && !this.state.cercaAvançada && !this.state.mapSelectOpen && !this.state.cercaOpen) {
        if (this.state.hadLlegenda) {
          this.setState({ llegendaOpen: true });
        }
        if (
          this.state.hadInfoPannel &&
          (this.state.infoPuntObert || this.state.taulaCapaObert || this.state.thumbnailsOpen || this.state.statsOpen)
        ) {
          this.onResizeInfoPuntCard(this.state.hadAltura);
        }
        this.setState({
          hadLlegenda: undefined,
          hadInfoPannel: undefined,
          hadAltura: undefined
        });
      }
    }
  };

  scrollToFiltre = (layer) => {
    let filtre = false;
    const filtreCheck = () => {
      filtre = document.getElementById(`filtre-${layer.getTitle()}`);
      if (filtre) {
        // Esperamos a la animación de abrirse de la capa
        setTimeout(() => {
          filtre.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 500);
      }
    };
    if (!filtre) {
      filtreCheck();
    }
  };

  onFavClick = (bool) => {
    this.setState({ favOpen: bool });
  };

  addToFav = (element, type, name, layer) => {
    if (type === 'coords') {
      for (let i = 0; i < this.state.favList.length; i++) {
        const fav = this.state.favList[i];
        if (fav.type === 'coords' && fav.fav[0] === element[0] && fav.fav[1] === element[1]) {
          this.deleteFav({ type: type, fav: element, name: name, layer: layer });
          return;
        }
      }
    } else {
      for (let i = 0; i < this.state.favList.length; i++) {
        const fav = this.state.favList[i];
        if (fav.type !== 'coords' && isDeepEqual(fav.fav.getProperties(), element.getProperties())) {
          this.deleteFav({ type: type, fav: element, name: name, layer: layer });
          return;
        }
      }
    }
    this.setState((prevState) => ({
      favList: [...prevState.favList, { type: type, fav: element, name: name, layer: layer }]
    }));
  };

  clearFav = () => {
    this.setState({ favList: [], favOpen: false });
  };

  goToFavFeature = (fav) => {
    const extent = fav.fav.getGeometry().getExtent();
    this.state.featureOverlay.getSource().clear();
    this.state.featureOverlay.getSource().addFeature(fav.fav);
    let coords = getCenter(extent);

    this.setState({ favFeatureInfo: fav }, () => {
      this.onClickMap([fav.fav], coords, coords, [coords[0], coords[1]], true);
      zoomMapToBBOX(this.state.map, extent, (window.innerHeight - 40) / 3);
      esborrarXinxeta(this.state.map);
    });
  };

  deleteFav = (fav) => {
    if (fav.type === 'coords') {
      this.setState((prevState) => ({
        favList: prevState.favList.filter((obj) => {
          if (obj.type === 'coords') {
            return JSON.stringify(obj.fav) !== JSON.stringify(fav.fav);
          } else {
            return true;
          }
        })
      }));
    } else {
      this.setState((prevState) => ({
        favList: prevState.favList.filter((obj) => {
          if (obj.type !== 'coords') {
            return !isDeepEqual(obj.fav.getProperties(), fav.fav.getProperties());
          } else {
            return true;
          }
        })
      }));
    }
  };

  setStatslayer = (layer, value) => {
    this.setState({ statsLayer: layer, statsValue: value }, () => {
      this.onResizeInfoPuntCard((window.innerHeight - 40) / 3);
      this.tableInfoToggle('stats');
    });
  };

  setEditing = async (bool, layer, type, editFeature, apiGeom) => {
    const { isEditing: isEditingState } = this.state;

    if (!bool) {
      this.stopEditing();
      return;
    }

    this.changeLlegendaOpen(false);

    if (bool === true) {
      this.startEditing(editFeature, layer, type, apiGeom);
    } else if (bool === 'draw') {
      this.startDrawing(layer, type);
    } else if (bool === 'deleteGeom' && !isEditingState.isEditing) {
      this.deleteGeometry(editFeature, layer, type);
    }
  };

  stopEditing = () => {
    this.setState({
      isEditing: { isEditing: false, feature: null, layer: null, type: null, isDrawing: false },
      infoPuntObert: false,
      showEditCard: true,
      editCardProps: undefined
    });

    this.editSource.clear();
    this.removeEditInteraction();
    this.toggleDrawing(false);
    this.onResizeInfoPuntCard(0);
    this.state.featureOverlay.getSource().clear();
    esborrarXinxeta(this.state.map);
  };

  removeEditInteraction = () => {
    let editInteraction = this.state.map
      .getInteractions()
      .getArray()
      .find((interaction) => interaction.get('name') === 'edit');

    if (editInteraction) {
      this.state.map.removeInteraction(editInteraction);
    }
  };

  startEditing = async (editFeature, layer, type, apiGeom) => {
    this.toggleDrawing(true);

    if (type === 'edit') {
      if (apiGeom) {
        this.editSource.addFeatures(apiGeom);
        const extent = apiGeom.reduce((acc, feature) => {
          return acc ? acc.extend(feature.getGeometry().getExtent()) : feature.getGeometry().getExtent();
        }, null);
        zoomMapToBBOX(this.state.map, extent, this.state.alturaInfoPunt);
      } else {
        this.editSource.addFeature(editFeature);
        const extent = editFeature.getGeometry().getExtent();
        zoomMapToBBOX(this.state.map, extent, this.state.alturaInfoPunt);
      }

      this.state.featureOverlay.getSource().clear();
    }
    while (this.editSource.getFeatures().length === 0) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    const feature = this.editSource.getFeatures()[0];
    const featExtent = feature.getGeometry().getExtent();
    const coords = getCenter(featExtent);
    if (this.state.showEditCard) {
      this.onClickMap([], coords, coords, [coords[0], coords[1]], false);
    }

    this.setState({
      isEditing: { isEditing: true, layer: layer, type: type, isDrawing: true }
    });
  };

  startDrawing = (layer, type) => {
    this.toggleDrawing(true);
    this.onResizeInfoPuntCard(0);
    this.setState({
      isEditing: { isEditing: true, layer: layer, type: type, isDrawing: true }
    });
  };

  deleteGeometry = (editFeature, layer, type) => {
    const elements = splitGeom(editFeature);
    this.editSource.addFeatures(elements);
    this.setState({
      isEditing: {
        isEditing: true,
        layer: layer,
        type: type,
        editFeature: editFeature
      }
    });
  };
  /**
   * @desc Función encargada de crear un modal
   * @param {boolean} bool Booleano, true abre el modal y false lo cierra
   * @param {Component} Component Componente que se usará en el cuerpo del modal
   * @param {string} title Título del modal
   * @param {boolean} bg Si se pasa true, genera un background que inutiliza el resto de la aplicación para centrar la atención al modal
   * @param {function} callback create/edit
   * @param {boolean} center Si el modal se muestra en el centro de la pantalla o abajo
   */
  toggleAlert = (bool, Component, title, bg, callback, center) => {
    this.setState(
      {
        modalState: {
          showAlert: bool,
          alertTitle: title ? title : 'Alerta',
          alertComponent: bool ? Component : null,
          background: bg,
          center: center
        }
      },
      callback ? callback : null
    );
  };

  render() {
    const size = 80;
    const position = `calc(50% - ${size / 2}px)`;
    return (
      <>
        <HipermapaContainer id="hipermapaContainer">
          {this.state.loading && (
            <Oval
              height={size}
              width={size}
              color="#febf00"
              wrapperStyle={{ position: 'absolute', zIndex: 1, top: position, left: position }}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#ccc"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          )}
          <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={true}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={true}
            theme="colored"
          />
          {this.state.modalState.showAlert && (
            <AlertModal
              altura={this.state.modalState.center ? 3 / 7 : this.state.alturaInfoPunt}
              component={this.state.modalState.alertComponent}
              title={this.state.modalState.alertTitle}
              background={this.state.modalState.background}
              center={this.state.modalState.center}
              toggleAlert={this.toggleAlert}
            />
          )}
          {/* {this.state.modalIniciOpen && this.props.id === config.idIntranet && (
            <ModalIniciIntranet
              modalIniciOpen={this.state.modalIniciOpen}
              toggleModal={this.toggleModal}
              fontSizeEnabled={this.state.fontSizeEnabled}
            />
          )}
          {this.state.modalIniciOpen && this.props.id === config.idHipermapa && (
            <ModalInici modalIniciOpen={this.state.modalIniciOpen} toggleModal={this.toggleModal} fontSizeEnabled={this.state.fontSizeEnabled} />
          )} */}
          {this.state.isEditing.isEditing && (
            <EdicioCapa
              showEditCard={this.state.showEditCard}
              user={this.state.user?.user}
              toggleAlert={this.toggleAlert}
              editVector={this.editVector}
              setEditing={this.setEditing}
              mode={this.state.isEditing.type}
              editFeature={this.state.isEditing.editFeature}
              map={this.state.map}
              toggleDrawing={this.toggleDrawing}
              layer={this.state.isEditing.layer}
            />
          )}
          {displayComponents.ajuda && this.state.ajudaOpen && (
            <Ajuda
              toggleAjuda={this.toggleAjuda}
              ajudaOpen={this.state.ajudaOpen}
              arrayLayers={this.state.arrayLayers}
              favList={this.state.favList}
              fontSizeEnabled={this.state.fontSizeEnabled}
            />
          )}
          {this.state.modalShareOpen && (
            <Compartir
              // intranet={this.props.visor?.login}
              intranet={this.props.id === config.idIntranet}
              user={this.state.user}
              toggleAlert={this.toggleAlert}
              mapName={this.props.visor?.mapName}
              favList={this.state.favList}
              vectorTilesSource={this.vectorTilesSource}
              loadMap={this.props.loadMap}
              transparenciaFons={this.state.transparenciaFons[this.state.fonsActiu]}
              toggleAjuda={this.toggleAjuda}
              toggleFontSize={this.toggleFontSize}
              modalShareKind={this.state.modalShareKind}
              modalShareOpen={this.state.modalShareOpen}
              toggleShare={this.toggleShare}
              fontSizeEnabled={this.state.fontSizeEnabled}
              map={this.state.map}
              arrayLayers={this.state.arrayLayers}
              fonsActiu={Data.fons[this.state.fonsActiu].tileName}
              alturaInfoPunt={this.state.alturaInfoPunt}
            />
          )}
          <NavbarContainer id="navbarContainer">
            {displayComponents.navbar && (
              <Navbar
                // intranet={this.props.visor?.login}
                intranet={this.props.id === config.idIntranet}
                user={this.state.user}
                onClickInfoPunt={this.onClickInfoPunt()}
                modalShareOpen={this.state.modalShareOpen}
                modalShareKind={this.state.modalShareKind}
                handleCercaAvançadaOpen={this.handleCercaAvançadaOpen}
                cercaAvançada={this.state.cercaAvançada}
                toggleAutoTab={this.toggleAutoTab}
                toggleShare={this.toggleShare}
                closeInfo={this.closeInfo}
                map={this.state.map}
                ajudaOpen={this.state.ajudaOpen}
                windowWidth={this.state.windowWidth}
                toggleAjuda={this.toggleAjuda}
                toggleError={this.toggleError}
                toggleFontSize={this.toggleFontSize}
                navbarObj={navbarObj}
                toggleMenuLateral={this.toggleMenuLateral}
                isOpen={this.state.isOpen}
                onClickCloseCerca={() => this.onClickCloseCerca()}
                onClickCerca={() => this.onClickCerca()}
                fontSizeEnabled={this.state.fontSizeEnabled}
                arrayLayers={this.state.arrayLayers}
                scale={this.state.scale}
              />
            )}
          </NavbarContainer>

          {displayComponents.infoA11y && (
            <InfoAccessibilitat
              toggleInfo={this.toggleInfoAccessibilitat}
              infoOpen={this.state.infoOpenAccess}
              fontSizeEnabled={this.state.fontSizeEnabled}
              mapHeight={this.state.mapHeight}
            />
          )}
          {displayComponents.infoCookies && (
            <InfoCookies
              toggleInfo={this.toggleInfoCookies}
              infoOpen={this.state.infoOpenCookies}
              fontSizeEnabled={this.state.fontSizeEnabled}
              mapHeight={this.state.mapHeight}
            />
          )}
          {displayComponents.cataleg && (
            <CatalogContainer id="catalogContainer">
              <Catalog
                capabilities={this.state.capabilities}
                map={this.state.map}
                catalogObj={catalogObj}
                catalogOpen={this.state.catalogOpen}
                toggleCat={this.toggleCatalog}
                mapHeight={this.state.mapHeight}
                infoPuntObert={this.state.infoPuntObert}
                alturaBtnCataleg={this.state.alturaBtnCataleg + 'px'}
                arrayLayers={this.state.arrayLayers}
                arrayExternalLayers={this.state.arrayExternalLayers}
                sitepLayerMap={this.state.sitepLayerMap}
                externalDefaultLayers={this.state.externalDefaultLayers}
                hideBottomButtons={this.state.hideBottomButtons}
                catalogData={this.state.catalogData}
                handleLayerArrayChange={() => this.handleLayerArrayChange()}
                fontSizeEnabled={this.state.fontSizeEnabled}
                displayNav={displayComponents.navbar}
              />
            </CatalogContainer>
          )}
          {displayComponents.sidebar && (
            <SidebarContainer id="sidebarContainer">
              <Sidebar
                visor={this.props.visor}
                toggleInfoAccessibilitat={this.toggleInfoAccessibilitat}
                toggleInfoCookies={this.toggleInfoCookies}
                isOpen={this.state.isOpen}
                toggleMenuLateral={this.toggleMenuLateral}
                toggleAjuda={this.toggleAjuda}
                fontSizeEnabled={this.state.fontSizeEnabled}
              />
            </SidebarContainer>
          )}
          {displayComponents.ubicacio && (
            <Location
              id="location"
              onClickGeolocalitzacioMapa={(coords) => this.onClickGeolocalitzacioMapa(coords)}
              onGeolocalitzacioError={(err) => this.onGeolocalitzacioError(err)}
              infoPuntObert={this.state.infoPuntObert}
              alturaBtnLocation={this.state.alturaBtnSelectorFons + 50}
              hideBottomButtons={this.state.hideBottomButtons}
            />
          )}
          {this.state.favList.length > 0 && displayComponents.preferits && (
            <Preferits
              onClickMap={this.onClickMap}
              deleteFav={this.deleteFav}
              goToFavFeature={this.goToFavFeature}
              alturaBtnFav={window.innerWidth > 768 ? this.state.alturaBtnSelectorFons + 95 : this.state.alturaBtnSelectorFons + 105}
              featureOverlay={this.state.featureOverlay}
              clearFav={this.clearFav}
              map={this.state.map}
              alturaInfoPunt={this.state.alturaInfoPunt}
              favOpen={this.state.favOpen}
              fontSizeEnabled={this.state.fontSizeEnabled}
              onFavClick={this.onFavClick}
              favList={this.state.favList}
            />
          )}
          <MapContainer
            id="mapContainer"
            mapHeight={displayComponents.navbar === true ? this.state.mapHeight : `${parseInt(this.state.mapHeight) + 40}px`}
            mapWidth={this.state.mapWidth}
            displayNav={displayComponents.navbar}
          />
          {displayComponents.einesMesura || (!displayComponents.einesMesura && this.state.apiDraw !== 'disable') ? (
            <VectorTilesTools
              apiEnabled={this.state.apiEnabled}
              apiFunctions={this.state.apiFunctions}
              apiDraw={this.state.apiDraw}
              isEditing={this.state.isEditing.isEditing}
              showAlert={this.state.modalState.showAlert}
              displayNav={displayComponents.navbar}
              vectorTilesVector={this.vectorTilesVector}
              vectorTilesSource={this.vectorTilesSource}
              hideBottomButtons={this.state.hideBottomButtons}
              map={this.state.map}
              toggleAlert={this.toggleAlert}
              toggleDrawing={this.toggleDrawing}
              showMedidas={this.state.showMedidas}
              toggleMedidas={this.toggleMedidas}
            />
          ) : null}

          {displayComponents.llegenda && (
            <Llegenda
              taulaApiConditions={this.state.taulaApiConditions}
              taulaFc={this.state.taulaFc}
              taulaGeom={this.state.taulaGeom}
              taulaTotal={this.state.taulaTotal}
              taulaPage={this.state.taulaPage}
              setTaulaGeom={this.setTaulaGeom}
              updateLlegenda={this.state.updateLlegenda}
              handleDeleteLayer={this.handleDeleteLayer}
              user={this.state.user?.user}
              getExternTable={this.getExternTable}
              isEditing={this.state.isEditing.isEditing}
              editVector={this.editVector}
              setEditing={this.setEditing}
              statsLayer={this.state.statsLayer}
              statsLayerSelect={this.setStatslayer}
              scrollToFiltre={this.scrollToFiltre}
              closeTable={this.closeTable}
              toggleMapSelector={this.toggleMapSelector}
              showAlert={this.state.modalState.showAlert}
              setTaulaSpacialBbox={this.setTaulaSpacialBbox}
              taulaSpacialBbox={this.state.taulaSpacialBbox}
              taulaFullFilter={this.state.taulaFullFilter}
              setTaulaSpacialFilter={this.setTaulaSpacialFilter}
              taulaSpacialFilter={this.state.taulaSpacialFilter}
              setTaulaLayer={this.setTaulaLayer}
              deleteTaula={this.deleteTaula}
              setTaulaResp={this.setTaulaResp}
              taulaResp={this.state.taulaResp}
              setTaulaConditions={this.setTaulaConditions}
              taulaConditions={this.state.taulaConditions}
              taulaArray={this.state.taulaArray}
              taulaLayer={this.state.taulaLayer}
              taulaOpen={this.state.taulaCapaObert}
              selectVector={this.selectVector}
              featureOverlay={this.state.featureOverlay}
              taulaFilters={this.state.taulaFilters}
              isSelecting={this.state.isSelecting}
              resetSelected={this.resetSelected}
              selectedArray={this.state.selectedArray}
              selectedFeatures={this.state.selectedFeatures}
              toggleSelecting={this.toggleSelecting}
              setTaulaFilters={this.setTaulaFilters}
              getTaulaArray={this.getTaulaArray}
              scale={this.state.scale}
              alturaInfoPunt={this.state.alturaInfoPunt}
              map={this.state.map}
              arrayLayers={this.state.arrayLayers}
              arrayExternalLayers={this.state.arrayExternalLayers}
              onClickInfoPunt={(operacio) => this.onClickInfoPunt(operacio)}
              llegendaOpen={this.state.llegendaOpen}
              changeLlegendaOpen={(isOpen) => this.changeLlegendaOpen(isOpen)}
              handleLayerArrayChange={() => this.handleLayerArrayChange()}
              infoPuntObert={this.state.infoPuntObert}
              fontSizeEnabled={this.state.fontSizeEnabled}
              handleEraseInfoCard={this.handleEraseInfoCard}
              toggleDrawing={this.toggleDrawing}
              filterVector={this.filterVector}
              filterSource={this.filterSource}
              toggleAlert={this.toggleAlert}
            />
          )}
          {displayComponents.selectorFons && (
            <SelectorFonsCartografic
              toggleMapSelector={this.toggleMapSelector}
              isOpen={this.state.mapSelectOpen}
              onChangeFonsActiuMapa={(nFons) => this.onChangeFonsActiuMapa(nFons)}
              fonsData={Data.fons}
              changeLlegendaOpen={this.changeLlegendaOpen}
              fonsActiu={this.state.fonsActiu}
              transparenciaFons={this.state.transparenciaFons}
              onChangeTransparenciaMapa={(i, transp) => this.onChangeTransparenciaMapa(i, transp)}
              infoPuntObert={this.state.infoPuntObert}
              alturaBtnSelectorFons={this.state.alturaBtnSelectorFons}
              alturaBtnSelectorFonsAux={this.state.alturaBtnSelectorFons + (window.innerWidth <= 768 ? 10 : 9) + 'px'}
              hideBottomButtons={this.state.hideBottomButtons}
              fontSizeEnabled={this.state.fontSizeEnabled}></SelectorFonsCartografic>
          )}
          {displayComponents.galeria && this.state.galeriaOpen && (
            <Galeria index={this.state.galeriaIndex} fotos={this.state.galeria.fotos} toggleGaleria={this.toggleGaleria}></Galeria>
          )}

          {(this.state.infoPuntObert || this.state.taulaCapaObert || this.state.thumbnailsOpen || this.state.statsOpen) && (
            <Informacio
              showEditCard={this.state.showEditCard}
              editCardProps={this.state.editCardProps}
              taulaGeom={this.state.taulaGeom}
              apiEnabled={this.state.apiEnabled}
              apiFunctions={this.state.apiFunctions}
              taulaSorting={this.state.taulaSorting}
              setTaulaSorting={this.setTaulaSorting}
              getExternTable={this.getExternTable}
              toggleAlert={this.toggleAlert}
              editVector={this.editVector}
              editFeature={this.editSource.getFeatures()[0]}
              setEditing={this.setEditing}
              isEditing={this.state.isEditing}
              closeStatsTab={this.closeStatsTab}
              statsOpen={this.state.statsOpen}
              statsLayer={this.state.statsLayer}
              statsValue={this.state.statsValue}
              favFeatureInfo={this.state.favFeatureInfo}
              addToFav={this.addToFav}
              favList={this.state.favList}
              taulaSpacialBbox={this.state.taulaSpacialBbox}
              scrollToFiltre={this.scrollToFiltre}
              buttonsActive={!(this.state.hadInfoPannel || this.state.hadLlegenda)}
              catalogOpen={this.state.catalogOpen}
              cercaOpen={this.state.cercaOpen}
              cercaAvançada={this.state.cercaAvançada}
              closeThumbnails={this.closeThumbnails}
              closeInfoTab={this.closeInfoTab}
              thumbnailsOpen={this.state.thumbnailsOpen}
              fotos={this.state.galeria.fotos}
              galeriaLayer={this.state.galeria.layer}
              infoPuntObert={this.state.infoPuntObert}
              taulaCapaObert={this.state.taulaCapaObert}
              closeAllTabs={this.closeAllTabs}
              closeInfoPunt={this.closeInfoPunt}
              alçada={this.state.alçada}
              tableInfoToggle={this.tableInfoToggle}
              deleteTaula={this.deleteTaula}
              setTaulaLayer={this.setTaulaLayer}
              changeLlegendaOpen={this.changeLlegendaOpen}
              taulaFc={this.state.taulaFc}
              taulaLoading={this.state.taulaLoading}
              taulaTotal={this.state.taulaTotal}
              taulaFullFilter={this.state.taulaFullFilter}
              updateTablePage={this.updateTablePage}
              taulaPage={this.state.taulaPage}
              taulaLayer={this.state.taulaLayer}
              taulaFilters={this.state.taulaFilters}
              getTaulaArray={this.getTaulaArray}
              taulaArray={this.state.taulaArray}
              alturaInfoPunt={this.state.alturaInfoPunt}
              coords={this.state.clickCoords}
              map={this.state.map}
              onClickInfoPunt={this.onClickInfoPunt}
              onResizeInfoPuntCard={(newInfoCardHeigth) => this.onResizeInfoPuntCard(newInfoCardHeigth)}
              featureCollect={this.state.featureCollect}
              infoPuntInfo={this.state.infoPuntInfo}
              featureOverlay={this.state.featureOverlay}
              arrayLayers={this.state.arrayLayers}
              fontSizeEnabled={this.state.fontSizeEnabled}
              setFotos={this.setFotos}
              toggleGaleria={this.toggleGaleria}
              table={Object.keys(this.state.taulaArray).length > 0}
              selected={new Array(this.state.infoPuntInfo?.length).fill(false).fill(true, 0, 1)}
              displayInfoPuntBody={this.state.displayInfoPuntBody}
              nCards={this.state.nCards}
              layersSelectedOnClick={this.state.layersSelectedOnClick}
              municipi={this.state.municipi}
              carrer={this.state.adreça}
            />
          )}

          {displayComponents.cerca && (
            <Cerca
              apiTab={this.state.apiTab}
              sitepLayerInfoMap={this.state.sitepLayerInfoMap}
              toggleAutoTab={this.toggleAutoTab}
              autoTab={this.state.autoTab}
              isLoadingCapa={this.state.isLoadingCapa}
              isLoadingEle={this.state.isLoadingEle}
              isLoadingLoc={this.state.isLoadingLoc}
              cercaHeight={this.state.mapHeight}
              isOpen={this.state.cercaOpen}
              infoPuntObert={this.state.infoPuntObert}
              onClickCerca={() => this.onClickCerca()}
              onClickCloseCerca={() => this.onClickCloseCerca()}
              handleCercaBuida={() => this.handleCercaBuida()}
              arElements={this.arElements}
              arCapesCataleg={this.arCapesCataleg}
              arSolr={this.arSolr}
              catalogData={this.state.catalogData?.LayerList.Layer}
              onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                this.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
              }
              addLayerToLlegenda={(capa) => this.addLayerToLlegenda(capa)}
              fontSizeEnabled={this.state.fontSizeEnabled}></Cerca>
          )}
          {displayComponents.cercaAvançada && (
            <CercaAvançada
              sitepLayerInfoMap={this.state.sitepLayerInfoMap}
              layerNames={this.state.sitepLayerInfoMap}
              map={this.state.map}
              cercaAvançada={this.state.cercaAvançada}
              handleCercaAvançadaOpen={this.handleCercaAvançadaOpen}
              mapHeight={this.state.mapHeight}
              infoPuntObert={this.state.infoPuntObert}
              alturaBtnCataleg={this.state.alturaBtnCataleg + 'px'}
              hideBottomButtons={this.state.hideBottomButtons}
              fontSizeEnabled={this.state.fontSizeEnabled}
              addCercaToponim={this.addCercaToponim}
              clearArElements={this.clearArElements}
              onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                this.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
              }
              cercaSolr={this.cercaSolr}
              catalogData={this.state.catalogData?.LayerList.Layer}
            />
          )}
        </HipermapaContainer>
        <Outlet />
      </>
    );
  }
}
export default Hipermapa;
